import { memo } from "react";
// @mui
import { useTheme } from "@mui/material/styles";
import { Box } from "@mui/material";

// ----------------------------------------------------------------------

function BackgroundIllustration({ ...other }) {
  const theme = useTheme();

  console.log(theme, "kjcbwijbeice");

  const PRIMARY_MAIN = theme.palette.vertex.blueLight;

  return (
    <Box {...other}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500">
        <g id="freepik--background-complete--inject-66">
          <path
            d="M286.88,350.61c-15.59-10.82-19.18-31-18.62-49.13.09-3-.25-6.22,1.18-8.88s4.79-4.49,7.5-3.22c2.25,1.05,3.24,3.66,4.51,5.82a17.7,17.7,0,0,0,7.12,6.77c1.93,1,4.32,1.59,6.22.54,2.6-1.45,2.9-5.06,2.87-8.07l-.15-16.84a28,28,0,0,1,.88-9c.93-2.86,3-5.52,5.85-6.33s6.41.83,7,3.78a27.5,27.5,0,0,1,.1,3.75c.09,1.25.67,2.63,1.86,3s2.41-.51,3.31-1.39c3.09-3.05,5.19-7,7.15-10.87s3.86-7.9,6.67-11.22,6.71-6,11-6.23,8.91,2.39,10,6.62-1.36,8.56-4.05,12a67.28,67.28,0,0,1-13.95,13.38,5.57,5.57,0,0,0-2.34,2.52c-.64,2,1.26,4,3.25,4.66,2.25.74,4.68.5,7,.77s4.9,1.29,5.79,3.51c1.24,3.07-1.32,6.31-3.85,8.43a57.5,57.5,0,0,1-17,9.89c-2.21.82-4.54,1.53-6.32,3.1s-2.86,4.27-1.77,6.38,3.86,2.8,6.18,2.36,4.39-1.71,6.6-2.55c4.13-1.57,9.48-1.3,12.14,2.27a9.53,9.53,0,0,1,1,8.42,22,22,0,0,1-4.54,7.46,58,58,0,0,1-24.68,17.45c-9.59,3.36-18.48,4.28-28,.82"
            fill="#f5f5f5"
          ></path>
          <path
            d="M291.53,339.23a270.07,270.07,0,0,1,10.62-29.09l3.18-7.48c1.05-2.45,2.09-4.88,3.25-7.2A136.29,136.29,0,0,1,316,282.53c2.57-4,5.15-7.69,7.59-11.13s4.79-6.6,7.05-9.39a107.48,107.48,0,0,1,11.62-12.37c1.48-1.34,2.67-2.35,3.48-3l.92-.76.33-.24a2.44,2.44,0,0,1-.29.28l-.89.8c-.79.7-1.95,1.74-3.4,3.11A111.68,111.68,0,0,0,331,262.26c-2.23,2.79-4.55,6-7,9.41s-5,7.15-7.54,11.14a138.06,138.06,0,0,0-7.39,12.9c-1.15,2.3-2.18,4.72-3.23,7.17l-3.17,7.48a276.16,276.16,0,0,0-10.64,29"
            fill="#e0e0e0"
          ></path>
          <path
            d="M308.74,295.44a5.93,5.93,0,0,1-.3-1.28c-.16-.84-.35-2.05-.57-3.55-.44-3-.89-7.15-1.38-11.74s-1-8.73-1.49-11.71c-.23-1.49-.44-2.7-.59-3.53a6.2,6.2,0,0,1-.17-1.31,5.8,5.8,0,0,1,.38,1.26c.22.82.48,2,.77,3.51.58,3,1.16,7.12,1.65,11.72s.89,8.62,1.22,11.75c.15,1.42.29,2.61.39,3.56A6.2,6.2,0,0,1,308.74,295.44Z"
            fill="#e0e0e0"
          ></path>
          <path
            d="M347.43,288.09a10.05,10.05,0,0,1-1.54.19c-1,.09-2.43.21-4.2.42-3.55.4-8.43,1.11-13.77,2.14s-10.15,2.17-13.6,3.1c-1.72.45-3.11.85-4.07,1.12a7.94,7.94,0,0,1-1.51.38,7.67,7.67,0,0,1,1.44-.58c.95-.34,2.32-.8,4-1.3,3.43-1,8.23-2.24,13.59-3.28a137.55,137.55,0,0,1,13.84-2c1.78-.16,3.23-.23,4.23-.25A7.76,7.76,0,0,1,347.43,288.09Z"
            fill="#e0e0e0"
          ></path>
          <path
            d="M292,338.51s-.11-.15-.26-.47l-.67-1.4c-.57-1.21-1.36-3-2.3-5.21-1.88-4.43-4.28-10.63-6.85-17.51s-4.91-13.1-6.69-17.56c-.88-2.17-1.6-3.95-2.13-5.28l-.58-1.44a1.93,1.93,0,0,1-.16-.52,2.26,2.26,0,0,1,.27.48l.66,1.39c.58,1.22,1.36,3,2.3,5.22,1.88,4.43,4.29,10.63,6.85,17.51s4.91,13.09,6.69,17.56l2.14,5.28q.33.85.57,1.44A2.06,2.06,0,0,1,292,338.51Z"
            fill="#e0e0e0"
          ></path>
          <path
            d="M343.4,321.78a1.9,1.9,0,0,1-.51.21l-1.49.5-5.51,1.81c-4.64,1.52-11,3.7-18.1,6.11s-13.48,4.54-18.16,6c-2.34.72-4.24,1.28-5.56,1.64l-1.53.4a1.68,1.68,0,0,1-.54.1,2.81,2.81,0,0,1,.51-.21l1.49-.5,5.51-1.81c4.65-1.52,11-3.69,18.1-6.11s13.49-4.54,18.17-6c2.34-.72,4.24-1.28,5.56-1.63l1.52-.41A1.72,1.72,0,0,1,343.4,321.78Z"
            fill="#e0e0e0"
          ></path>
          <path
            d="M54.05,93.85s-9.25,2.53-1.29,22.48,13.81,30,13.81,30,1.31,4.58-2.47,4.92-11.87-1.72-13.95,2.68c-2.16,4.56.86,9.34,7.46,13.9s20.68,15.06,22,16,2.38,3.12-.16,3.76-21.16.86-20.53,9.69,21.09,18.5,23.31,19.6,2.67,2.13,2.37,3.37-6.57.73-11.86,1-11.38,1.53-10.59,6.6,12.37,16.62,42.55,22.42l14.16,1.78,8.84-11.28c17.45-25.3,17.61-41.66,14.62-45.83s-8.2-.78-12.17,2.73-8.07,8.27-9.16,7.6-1.48-1.73-.67-4.07,8.62-23.58,2.88-30.32-19.17,6.16-21.43,7.49-3-1-2.76-2.58,2.92-18.94,4.43-26.81.31-13.4-4.43-15.14c-4.57-1.68-8.88,5.46-11.82,7.87S81.93,140,81.93,140s-2.87-11.28-11.19-31.08-16.87-15-16.87-15"
            fill="#ebebeb"
          ></path>
          <path
            d="M119.23,255.49c-6-14.57-16.36-40.64-25.33-63S76.78,150,70.81,135.36l-7.09-17.28-1.93-4.7-.49-1.22a4.49,4.49,0,0,1-.15-.43s.07.14.19.41.31.69.53,1.21c.47,1.08,1.14,2.65,2,4.67,1.73,4,4.2,9.94,7.22,17.23,6.05,14.56,14.24,34.76,23.21,57.09s19.24,48.43,25.21,63"
            fill="#e0e0e0"
          ></path>
          <path
            d="M61.33,157.29a4.17,4.17,0,0,1,1,.36c.61.26,1.48.67,2.55,1.17,2.14,1,5.06,2.51,8.26,4.2l8.16,4.37c1,.52,1.82,1,2.48,1.31a4.55,4.55,0,0,1,.9.51,4.17,4.17,0,0,1-1-.36c-.61-.26-1.48-.66-2.55-1.18-2.13-1-5-2.56-8.23-4.26l-8.19-4.3-2.49-1.3A5.8,5.8,0,0,1,61.33,157.29Z"
            fill="#e0e0e0"
          ></path>
          <path
            d="M85.7,168.39c-.11,0,2.68-6.21,6.24-13.75s6.52-13.62,6.63-13.57-2.68,6.21-6.23,13.76S85.81,168.45,85.7,168.39Z"
            fill="#e0e0e0"
          ></path>
          <path
            d="M97.93,203.32a4.79,4.79,0,0,1,.66-.83l1.9-2.14c1.59-1.82,3.79-4.33,6.11-7.2s4.35-5.52,5.79-7.45l1.72-2.3a4.44,4.44,0,0,1,.67-.81,4.75,4.75,0,0,1-.53.91c-.36.57-.91,1.39-1.6,2.38-1.38,2-3.37,4.69-5.7,7.55s-4.57,5.36-6.23,7.13c-.84.88-1.52,1.58-2,2.05A5,5,0,0,1,97.93,203.32Z"
            fill="#e0e0e0"
          ></path>
          <path
            d="M73.68,198.12a4.08,4.08,0,0,1,1,.11l2.61.45c2.2.4,5.23,1,8.57,1.66s6.37,1.3,8.56,1.78l2.58.59a4,4,0,0,1,.93.28,4.12,4.12,0,0,1-1-.11l-2.61-.45c-2.2-.4-5.23-1-8.57-1.66s-6.37-1.3-8.55-1.78l-2.59-.59A4,4,0,0,1,73.68,198.12Z"
            fill="#e0e0e0"
          ></path>
          <path
            d="M80.56,230.32a7.3,7.3,0,0,1,1.24.15l3.35.57c2.82.5,6.71,1.21,11,2s8.18,1.59,11,2.17l3.32.7a6.73,6.73,0,0,1,1.2.32,6.2,6.2,0,0,1-1.23-.15l-3.35-.56c-2.82-.5-6.71-1.22-11-2s-8.18-1.59-11-2.16l-3.32-.71A6.06,6.06,0,0,1,80.56,230.32Z"
            fill="#e0e0e0"
          ></path>
          <path
            d="M111,235.91a8.15,8.15,0,0,1,.81-1.06l2.3-2.81c2-2.37,4.62-5.66,7.47-9.37s5.35-7.14,7.14-9.63l2.12-2.95a7.41,7.41,0,0,1,.82-1.06,8.48,8.48,0,0,1-.68,1.16c-.46.72-1.14,1.76-2,3-1.72,2.54-4.18,6-7,9.72s-5.57,7-7.58,9.3c-1,1.16-1.83,2.09-2.41,2.72A7.77,7.77,0,0,1,111,235.91Z"
            fill="#e0e0e0"
          ></path>
          <rect
            x="344.71"
            y="142.41"
            width="75.83"
            height="79.04"
            fill="#e0e0e0"
          ></rect>
          <rect
            x="339.58"
            y="142.41"
            width="75.83"
            height="79.04"
            fill="#fafafa"
          ></rect>
          <path
            d="M415.43,221.47H339.55V142.38h75.88Zm-75.83,0h75.78v-79H339.6Z"
            fill="#e0e0e0"
          ></path>
          <rect
            x="349.77"
            y="153.03"
            width="55.44"
            height="57.79"
            fill="#fafafa"
          ></rect>
          <path
            d="M349.77,211.21a9,9,0,0,1-1.37,1.59c-.88.93-2.13,2.2-3.52,3.57s-2.68,2.6-3.63,3.47a8.26,8.26,0,0,1-1.6,1.33,9.22,9.22,0,0,1,1.36-1.58c.89-.93,2.14-2.2,3.53-3.58s2.69-2.6,3.63-3.47A8.63,8.63,0,0,1,349.77,211.21Z"
            fill="#e0e0e0"
          ></path>
          <path
            d="M405.21,211.07a8.47,8.47,0,0,1,1.59,1.37c.93.88,2.2,2.12,3.57,3.52s2.6,2.68,3.47,3.62a9,9,0,0,1,1.33,1.6,9.09,9.09,0,0,1-1.58-1.36c-.93-.88-2.2-2.13-3.58-3.53s-2.6-2.68-3.47-3.63A8.81,8.81,0,0,1,405.21,211.07Z"
            fill="#e0e0e0"
          ></path>
          <path
            d="M405.06,153.19a8.12,8.12,0,0,1,1.37-1.59c.88-.94,2.13-2.2,3.52-3.58s2.68-2.59,3.62-3.46a9.46,9.46,0,0,1,1.6-1.34,8.49,8.49,0,0,1-1.36,1.59c-.88.93-2.13,2.2-3.53,3.58s-2.68,2.6-3.63,3.47A8.81,8.81,0,0,1,405.06,153.19Z"
            fill="#e0e0e0"
          ></path>
          <path
            d="M349.62,153.33A8.58,8.58,0,0,1,348,152c-.94-.89-2.2-2.13-3.58-3.52s-2.59-2.68-3.46-3.63a8.61,8.61,0,0,1-1.34-1.6,9,9,0,0,1,1.59,1.36c.93.89,2.2,2.14,3.58,3.53s2.6,2.69,3.47,3.63A8.63,8.63,0,0,1,349.62,153.33Z"
            fill="#e0e0e0"
          ></path>
          <path
            d="M405.06,210.82a1.16,1.16,0,0,1,0-.28c0-.19,0-.46,0-.8,0-.73,0-1.77,0-3.12,0-2.74,0-6.72-.06-11.78,0-10.12-.06-24.54-.11-41.81l.22.22-55.29,0h0L350,153c0,21.21,0,41.06,0,57.79l-.21-.21,40,.11,11.25.06,3,0h1a1.15,1.15,0,0,1-.25,0h-.74l-2.94,0-11.19.06-40.17.11h-.21v-.22c0-16.73,0-36.58,0-57.79v-.24h.25l55.29,0h.21V153c0,17.32-.08,31.79-.11,41.95,0,5,0,9-.05,11.73,0,1.33,0,2.36,0,3.07,0,.34,0,.6,0,.79A2.06,2.06,0,0,1,405.06,210.82Z"
            fill="#e0e0e0"
          ></path>
          <rect
            x="368.24"
            y="172.68"
            width="18.5"
            height="18.5"
            fill="#ebebeb"
          ></rect>
          <rect
            x="401.57"
            y="52.56"
            width="7.61"
            height="37.85"
            transform="translate(-0.38 2.18) rotate(-0.31)"
            fill="#e0e0e0"
          ></rect>
          <rect
            x="335.63"
            y="52.69"
            width="19.7"
            height="20.9"
            transform="translate(-0.33 1.85) rotate(-0.31)"
            fill="#ebebeb"
          ></rect>
          <rect
            x="355.23"
            y="52.58"
            width="19.7"
            height="20.9"
            transform="translate(-0.33 1.95) rotate(-0.31)"
            fill="#f5f5f5"
          ></rect>
          <path
            d="M335.6,58.51c13.09.11,26.22,0,39.31-.18a.21.21,0,0,0,0-.42q-19.63-.1-39.3.24a.18.18,0,0,0,0,.36Z"
            fill="#e0e0e0"
          ></path>
          <rect
            x="323.33"
            y="73.28"
            width="35.79"
            height="17.03"
            transform="translate(-0.43 1.83) rotate(-0.31)"
            fill="#ebebeb"
          ></rect>
          <rect
            x="358.95"
            y="73.09"
            width="35.79"
            height="17.03"
            transform="translate(-0.43 2.02) rotate(-0.31)"
            fill="#f5f5f5"
          ></rect>
          <path
            d="M323.31,78.11c23.78.27,47.64,0,71.41-.35a.21.21,0,0,0,0-.42c-23.78-.13-47.64-.11-71.41.41a.18.18,0,0,0,0,.36Z"
            fill="#e0e0e0"
          ></path>
          <rect
            x="309.93"
            y="90.4"
            width="138.66"
            height="6.1"
            fill="#e0e0e0"
          ></rect>
          <rect
            x="332.63"
            y="93.34"
            width="5.63"
            height="20.82"
            fill="#e0e0e0"
          ></rect>
          <rect
            x="416.66"
            y="93.34"
            width="5.63"
            height="20.82"
            fill="#e0e0e0"
          ></rect>
          <rect
            x="409.03"
            y="38.44"
            width="7.61"
            height="52.06"
            transform="translate(-0.34 2.21) rotate(-0.31)"
            fill="#ebebeb"
          ></rect>
          <rect
            x="416.68"
            y="48.14"
            width="11.82"
            height="42.19"
            transform="translate(-0.37 2.27) rotate(-0.31)"
            fill="#f5f5f5"
          ></rect>
          <path
            d="M428.31,56.24a83.27,83.27,0,0,1-11.82,0,87.42,87.42,0,0,1,11.82,0Z"
            fill="#e0e0e0"
          ></path>
          <path
            d="M428.31,54.47a44,44,0,0,1-5.91.2,43.85,43.85,0,0,1-5.91-.2,83.27,83.27,0,0,1,11.82,0Z"
            fill="#e0e0e0"
          ></path>
          <path
            d="M428.31,84a83.27,83.27,0,0,1-11.82,0,87.42,87.42,0,0,1,11.82,0Z"
            fill="#e0e0e0"
          ></path>
          <path
            d="M428.31,82.18a83.27,83.27,0,0,1-11.82,0,87.42,87.42,0,0,1,11.82,0Z"
            fill="#e0e0e0"
          ></path>
          <path
            d="M422.59,78.31c-.11,0-.21-4.25-.21-9.5s.1-9.51.21-9.51.2,4.26.2,9.51S422.7,78.31,422.59,78.31Z"
            fill="#e0e0e0"
          ></path>
          <rect
            x="428.44"
            y="58.47"
            width="12.87"
            height="31.84"
            fill="#ebebeb"
          ></rect>
          <path
            d="M414.77,47.31a2.19,2.19,0,1,1-2.18-2.19A2.19,2.19,0,0,1,414.77,47.31Z"
            fill="#e0e0e0"
          ></path>
          <rect
            x="411.91"
            y="53.32"
            width="1.35"
            height="30.97"
            fill="#e0e0e0"
          ></rect>
        </g>
        <g id="freepik--Floor--inject-66">
          <path
            d="M475.59,463.09c0,.14-94.48.26-211,.26s-211-.12-211-.26,94.46-.26,211-.26S475.59,462.94,475.59,463.09Z"
            fill="#263238"
          ></path>
        </g>
        <g id="freepik--Screen--inject-66">
          <path
            d="M268.45,46.29l-25.91,0a6.43,6.43,0,0,0-6.29,6.58v4.7a6.44,6.44,0,0,1-6.3,6.57l-50.49,0a6.44,6.44,0,0,1-6.29-6.58v-4.7a6.44,6.44,0,0,0-6.29-6.58H135.09A20.38,20.38,0,0,0,114.7,66.59l-.07,327A20.38,20.38,0,0,0,135,414l133.36.08a20.38,20.38,0,0,0,20.39-20.38l.07-327A20.39,20.39,0,0,0,268.45,46.29Z"
            fill="#fff"
          ></path>
          <path
            d="M268.45,46.29l.69,0a14.64,14.64,0,0,1,2.07.16,19.15,19.15,0,0,1,7.65,2.64,19.56,19.56,0,0,1,4.65,3.77A20.35,20.35,0,0,1,287.39,59a21.1,21.1,0,0,1,1.53,8.28c0,3,0,6.22,0,9.61,0,27.16,0,66.46.07,115s0,106.38,0,170.58V393a21.9,21.9,0,0,1-.79,6.22,20.37,20.37,0,0,1-2.6,5.74,21.94,21.94,0,0,1-4.25,4.72,20.65,20.65,0,0,1-11.77,4.57c-4.27.12-8.52,0-12.81.05h-26l-53.28,0-27.25,0H136.55a21.5,21.5,0,0,1-13.27-3.66,20.93,20.93,0,0,1-8.09-11.16,22.76,22.76,0,0,1-.85-6.9v-6.87q0-13.72,0-27.26,0-27.08,0-53.3c0-34.94,0-68.64,0-100.75s0-62.61,0-91.17q0-21.4,0-41.31v-5c0-.82.08-1.65.12-2.47s.21-1.64.42-2.43a20.85,20.85,0,0,1,4.28-8.64A20.71,20.71,0,0,1,135.92,46l17.77,0h12.73a6.56,6.56,0,0,1,4,1.12,6.74,6.74,0,0,1,2.49,3.28,11.1,11.1,0,0,1,.42,4c0,.66,0,1.32,0,2a13.76,13.76,0,0,0,.07,1.94,6.4,6.4,0,0,0,1.52,3.41A6,6,0,0,0,178,63.74a7.1,7.1,0,0,0,1.84.18h9.24L216,64l11.85,0c.93,0,1.89,0,2.77,0a6,6,0,0,0,2.5-.88A6.47,6.47,0,0,0,236,59a12,12,0,0,0,.16-2.47V54.06a13.47,13.47,0,0,1,.11-2.38A6.74,6.74,0,0,1,237,49.5a6.4,6.4,0,0,1,3.25-2.88,10.31,10.31,0,0,1,4-.43l13.22,0,8.14,0,2.77,0-2.77,0-8.14,0-13.22,0a10,10,0,0,0-4,.43,6.29,6.29,0,0,0-3.15,2.8,6.74,6.74,0,0,0-.74,2.13,13.87,13.87,0,0,0-.1,2.34V56.5A11.37,11.37,0,0,1,236.2,59a6.71,6.71,0,0,1-2.95,4.26,6.29,6.29,0,0,1-2.6.92c-.94.08-1.85,0-2.8,0h-48a7.41,7.41,0,0,1-1.92-.19,6.31,6.31,0,0,1-3.29-2,6.78,6.78,0,0,1-1.61-3.59,14.83,14.83,0,0,1-.07-2v-2a10.63,10.63,0,0,0-.4-3.91,6.33,6.33,0,0,0-2.36-3.09,6.19,6.19,0,0,0-3.81-1.06h-30.5a20.26,20.26,0,0,0-16.3,7.24,20.41,20.41,0,0,0-4.19,8.46c-.2.77-.26,1.58-.4,2.37s-.1,1.61-.11,2.43v5q0,19.88,0,41.31V305.09q0,26.21,0,53.3v34.13a21.78,21.78,0,0,0,.83,6.73,20.28,20.28,0,0,0,7.85,10.85,20.94,20.94,0,0,0,13,3.57h41l53.28,0,26,0c4.28,0,8.57.07,12.78-.06a20,20,0,0,0,11.46-4.44,21.22,21.22,0,0,0,4.13-4.59,19.89,19.89,0,0,0,2.54-5.59,21.06,21.06,0,0,0,.76-6.07v-6.18q0-12.33,0-24.37c0-64.2.07-122,.1-170.58s.09-87.86.11-115l0-9.61A20.93,20.93,0,0,0,287.23,59,20.22,20.22,0,0,0,283.4,53a20.26,20.26,0,0,0-12.2-6.45,15.61,15.61,0,0,0-2.06-.19Z"
            fill="#263238"
          ></path>
          <path
            d="M272.35,83.7c0,.09-3.36.18-7.52.22s-7.53,0-7.53-.1,3.37-.18,7.53-.22S272.35,83.61,272.35,83.7Z"
            fill="#263238"
          ></path>
          <path
            d="M272.39,87.55c0,.09-3.37.19-7.53.22s-7.52,0-7.52-.1,3.36-.18,7.52-.22S272.39,87.46,272.39,87.55Z"
            fill="#263238"
          ></path>
          <path
            d="M272.42,91.4c0,.09-3.37.19-7.53.22s-7.52,0-7.52-.1,3.36-.18,7.52-.22S272.42,91.31,272.42,91.4Z"
            fill="#263238"
          ></path>
          <path
            d="M135.5,95.92l.31,0,.87,0,3.21-.07-.09.09c0-.72,0-1.5,0-2.33,0-.44,0-.85,0-1.35a1.23,1.23,0,0,1,1.08-1c.52,0,1,0,1.53,0a1.24,1.24,0,0,1,1.06,1.24c0,1.08,0,2.22,0,3.4l-.15-.15,4,0-.15.15c0-1.63,0-3.32,0-5,0-.43,0-.86,0-1.28a1.28,1.28,0,0,0-.57-1l-1.77-1.75-1.71-1.69-.83-.81a1.89,1.89,0,0,0-.84-.63,1.07,1.07,0,0,0-.93.18c-.24.21-.5.5-.75.74L138.31,86c-.91.95-1.86,1.82-2.56,2.64a2.86,2.86,0,0,0-.2,1.51v1.43c0,.87,0,1.64,0,2.3s0,1.07,0,1.47,0,.52,0,.53a2.83,2.83,0,0,1,0-.49c0-.39,0-.87,0-1.45s0-1.43-.05-2.31c0-.46,0-1,0-1.46,0-.26,0-.53,0-.8a1.64,1.64,0,0,1,.22-.85c.75-.92,1.64-1.73,2.57-2.71l1.44-1.48c.26-.25.47-.5.78-.77a1.38,1.38,0,0,1,1.18-.23,2.18,2.18,0,0,1,1,.69l.83.82,1.72,1.68,1.77,1.74a3.12,3.12,0,0,1,.46.49,1.4,1.4,0,0,1,.21.69c0,.43,0,.86,0,1.29,0,1.73,0,3.42,0,5V96h-.16l-4,0h-.15v-.15c0-1.18,0-2.31,0-3.4a1,1,0,0,0-.82-1c-.46,0-1,0-1.47,0a1,1,0,0,0-.87.79c0,.41,0,.88,0,1.29V96h-.09l-3.26,0h-.85A1.32,1.32,0,0,1,135.5,95.92Z"
            fill="#263238"
          ></path>
          <path
            d="M215.55,118A13.91,13.91,0,1,1,201.64,104,13.91,13.91,0,0,1,215.55,118Z"
            fill="#263238"
          ></path>
          <g opacity="0.4">
            <path
              d="M205.92,109.87v10.72H188.05s-1.2-6.63,2.44-11Z"
              fill="#455a64"
            ></path>
          </g>
          <path
            d="M199.44,115.4a3.49,3.49,0,1,1-3.49-3.48A3.48,3.48,0,0,1,199.44,115.4Z"
            fill="#263238"
          ></path>
          <path
            d="M206.59,124.86a4.26,4.26,0,1,1,4.26-4.26A4.26,4.26,0,0,1,206.59,124.86Zm0-7a2.71,2.71,0,1,0,2.71,2.7A2.7,2.7,0,0,0,206.59,117.9Z"
            fill="#5A9ED1"
          ></path>
          <path
            d="M196.19,115.12v11.37h16.44a13.3,13.3,0,0,0,2.63-11.37Z"
            fill="#fff"
          ></path>
          <path
            d="M210.07,120.8a3.49,3.49,0,1,1-3.48-3.48A3.48,3.48,0,0,1,210.07,120.8Z"
            fill="#263238"
          ></path>
          <rect
            x="157.74"
            y="345.24"
            width="87.9"
            height="26.85"
            rx="13.42"
            fill="#5A9ED1"
          ></rect>
          <path
            d="M181.9,357.05c0,1.46-1.06,2.35-2.81,2.35h-1.85v2.17h-.72v-6.88h2.57C180.84,354.69,181.9,355.57,181.9,357.05Zm-.72,0c0-1.1-.73-1.73-2.11-1.73h-1.83v3.44h1.83C180.45,358.76,181.18,358.13,181.18,357.05Z"
            fill="#fff"
          ></path>
          <path
            d="M187.19,358.36v3.21h-.67v-.81a1.94,1.94,0,0,1-1.78.86c-1.17,0-1.89-.61-1.89-1.5s.51-1.47,2-1.47h1.64v-.31c0-.89-.5-1.37-1.47-1.37a2.64,2.64,0,0,0-1.72.61l-.31-.52a3.24,3.24,0,0,1,2.1-.7A1.84,1.84,0,0,1,187.19,358.36Zm-.7,1.66v-.85h-1.62c-1,0-1.33.39-1.33.93s.48,1,1.31,1A1.66,1.66,0,0,0,186.49,360Z"
            fill="#fff"
          ></path>
          <path
            d="M193.33,356.4l-2.58,5.79c-.44,1-1,1.34-1.72,1.34a1.77,1.77,0,0,1-1.26-.47l.32-.53a1.29,1.29,0,0,0,.95.4c.46,0,.77-.22,1.07-.87l.22-.5L188,356.4h.73l1.95,4.39,1.94-4.39Z"
            fill="#fff"
          ></path>
          <path
            d="M199.22,361.62v1.13h-.49v-1.12a3.73,3.73,0,0,1-2.35-.89l.29-.57a3.31,3.31,0,0,0,2.06.83v-2.59c-1.08-.26-2.18-.6-2.18-1.89,0-.95.68-1.76,2.18-1.88v-1.13h.49v1.12a3.81,3.81,0,0,1,2,.61l-.24.58a3.65,3.65,0,0,0-1.76-.57v2.6c1.12.27,2.29.58,2.29,1.9C201.51,360.71,200.79,361.53,199.22,361.62Zm-.49-3.89v-2.46c-1,.09-1.46.61-1.46,1.23S197.93,357.52,198.73,357.73Zm2.06,2.06c0-.78-.72-1-1.57-1.25V361C200.31,360.92,200.79,360.42,200.79,359.79Z"
            fill="#fff"
          ></path>
          <path
            d="M207,359.59c0,1.16-.84,2-2.5,2a3.57,3.57,0,0,1-2.48-.88l.34-.57a3,3,0,0,0,2.14.8c1.14,0,1.77-.53,1.77-1.39s-.58-1.36-1.86-1.36h-.49v-.52l1.9-2.39h-3.52v-.63h4.43v.5l-1.95,2.45C206.22,357.72,207,358.49,207,359.59Z"
            fill="#fff"
          ></path>
          <path
            d="M212.52,359.55c0,1.17-.81,2.08-2.5,2.08a3.54,3.54,0,0,1-2.46-.88l.34-.57a2.94,2.94,0,0,0,2.11.8c1.17,0,1.79-.57,1.79-1.41s-.55-1.43-2.3-1.43H208l.35-3.45h3.77v.63H209l-.23,2.19h.88C211.74,357.51,212.52,358.33,212.52,359.55Z"
            fill="#fff"
          ></path>
          <path
            d="M213.43,361.08a.51.51,0,0,1,.52-.53.53.53,0,0,1,.53.53.54.54,0,0,1-.53.54A.53.53,0,0,1,213.43,361.08Z"
            fill="#fff"
          ></path>
          <path
            d="M215.39,358.13c0-2.19,1.15-3.5,2.75-3.5s2.75,1.31,2.75,3.5-1.16,3.5-2.75,3.5S215.39,360.32,215.39,358.13Zm4.77,0c0-1.84-.82-2.85-2-2.85s-2,1-2,2.85.83,2.85,2,2.85S220.16,360,220.16,358.13Z"
            fill="#fff"
          ></path>
          <path
            d="M221.91,358.13c0-2.19,1.15-3.5,2.74-3.5s2.75,1.31,2.75,3.5-1.16,3.5-2.75,3.5S221.91,360.32,221.91,358.13Zm4.76,0c0-1.84-.82-2.85-2-2.85s-2,1-2,2.85.83,2.85,2,2.85S226.67,360,226.67,358.13Z"
            fill="#fff"
          ></path>
          <path
            d="M277,230.35c0,.14-32.59.26-72.77.26s-72.78-.12-72.78-.26,32.58-.26,72.78-.26S277,230.21,277,230.35Z"
            fill="#e0e0e0"
          ></path>
          <path
            d="M273.63,294.33c0,.15-32.59.26-72.77.26s-72.78-.11-72.78-.26,32.58-.26,72.78-.26S273.63,294.19,273.63,294.33Z"
            fill="#263238"
          ></path>
          <path
            d="M273.63,329.63c0,.14-32.59.26-72.77.26s-72.78-.12-72.78-.26,32.58-.26,72.78-.26S273.63,329.48,273.63,329.63Z"
            fill="#263238"
          ></path>
          <path
            d="M188.19,302.06h-2.4v-.62h5.51v.62h-2.39v6.19h-.72Z"
            fill="#263238"
          ></path>
          <path d="M191.61,305.31h2.56v.61h-2.56Z" fill="#263238"></path>
          <path
            d="M195,307.67l.31-.55a3.13,3.13,0,0,0,1.82.58c1,0,1.38-.33,1.38-.84,0-1.33-3.32-.28-3.32-2.31,0-.83.72-1.46,2-1.46a3.44,3.44,0,0,1,1.81.48l-.3.55a2.63,2.63,0,0,0-1.51-.43c-.92,0-1.33.36-1.33.84,0,1.39,3.32.34,3.32,2.31,0,.89-.78,1.46-2.11,1.46A3.44,3.44,0,0,1,195,307.67Z"
            fill="#263238"
          ></path>
          <path
            d="M205.19,305.28v3h-.69v-2.9a1.43,1.43,0,0,0-1.54-1.63,1.67,1.67,0,0,0-1.79,1.84v2.69h-.69V301h.69v3a2.15,2.15,0,0,1,1.92-.94A2,2,0,0,1,205.19,305.28Z"
            fill="#263238"
          ></path>
          <path
            d="M206.91,301.52a.5.5,0,0,1,.51-.49.49.49,0,1,1,0,1A.5.5,0,0,1,206.91,301.52Zm.16,1.61h.69v5.12h-.69Z"
            fill="#263238"
          ></path>
          <path
            d="M212.27,303.09v.67h-.17a1.66,1.66,0,0,0-1.72,1.89v2.61h-.69v-5.12h.66v1A1.93,1.93,0,0,1,212.27,303.09Z"
            fill="#263238"
          ></path>
          <path
            d="M216.43,307.94a1.66,1.66,0,0,1-1.08.36,1.35,1.35,0,0,1-1.49-1.49v-3.09h-.92v-.59h.92V302h.69v1.12h1.55v.59h-1.55v3a.82.82,0,0,0,.88.94,1.12,1.12,0,0,0,.76-.27Z"
            fill="#263238"
          ></path>
          <path
            d="M183.74,322.49V324h-1.09V322.5a5.79,5.79,0,0,1-3.26-1.1l.6-1.35a5,5,0,0,0,2.66,1v-2.65c-1.48-.36-3.06-.84-3.06-2.69,0-1.35,1-2.54,3.06-2.74v-1.5h1.09V313a5.56,5.56,0,0,1,2.69.81l-.54,1.34a5.58,5.58,0,0,0-2.15-.72v2.69c1.47.36,3.08.82,3.08,2.67C186.82,321.1,185.82,322.27,183.74,322.49Zm-1.09-5.69v-2.37c-1,.15-1.35.63-1.35,1.21S181.88,316.57,182.65,316.8Zm2.47,3.07c0-.65-.59-1-1.38-1.18V321C184.71,320.89,185.12,320.44,185.12,319.87Z"
            fill="#263238"
          ></path>
          <path
            d="M194.4,319.59c0,1.57-1.18,2.92-3.68,2.92a5.88,5.88,0,0,1-3.49-1.07l.74-1.35a4.34,4.34,0,0,0,2.73.92c1.23,0,2-.54,2-1.41s-.61-1.38-2-1.38h-.85V317l2.11-2.51h-4.22v-1.45H194v1.15l-2.26,2.69A2.64,2.64,0,0,1,194.4,319.59Z"
            fill="#263238"
          ></path>
          <path
            d="M202.16,319.52c0,1.64-1.18,3-3.68,3a5.87,5.87,0,0,1-3.5-1.07l.73-1.35a4.41,4.41,0,0,0,2.74.92c1.24,0,2-.54,2-1.42s-.57-1.45-2.5-1.45h-2.25l.48-5.06h5.47v1.45h-4l-.2,2.15h.89C201.06,316.68,202.16,317.87,202.16,319.52Z"
            fill="#263238"
          ></path>
          <path
            d="M203.1,321.37a1.09,1.09,0,1,1,2.18,0,1.09,1.09,0,1,1-2.18,0Z"
            fill="#263238"
          ></path>
          <path
            d="M206.23,317.73c0-3.06,1.68-4.79,3.89-4.79s3.89,1.73,3.89,4.79-1.67,4.78-3.89,4.78S206.23,320.79,206.23,317.73Zm6,0c0-2.25-.88-3.28-2.15-3.28s-2.14,1-2.14,3.28.87,3.28,2.14,3.28S212.27,320,212.27,317.73Z"
            fill="#263238"
          ></path>
          <path
            d="M215.17,317.73c0-3.06,1.68-4.79,3.88-4.79s3.9,1.73,3.9,4.79-1.68,4.78-3.9,4.78S215.17,320.79,215.17,317.73Zm6,0c0-2.25-.88-3.28-2.16-3.28s-2.13,1-2.13,3.28.87,3.28,2.13,3.28S221.21,320,221.21,317.73Z"
            fill="#263238"
          ></path>
          <path
            d="M133.51,244.42V249a.57.57,0,0,0,.57.59h9.73a.58.58,0,0,0,.58-.59v-4.57"
            fill="#263238"
          ></path>
          <path
            d="M133.51,243.05h10.73s0-1.28-.92-1.28h-9S133.43,241.85,133.51,243.05Z"
            fill="#263238"
          ></path>
          <path
            d="M137.83,248.16c0,.44-.52.79-1.17.79s-1.18-.35-1.18-.79.53-.78,1.18-.78S137.83,247.73,137.83,248.16Z"
            fill="#263238"
          ></path>
          <path
            d="M149.44,246.17a2,2,0,0,1,2.06-2,1.87,1.87,0,0,1,1.43.58l-.26.27a1.51,1.51,0,0,0-1.16-.48,1.65,1.65,0,1,0,0,3.3,1.54,1.54,0,0,0,1.16-.47l.26.26a1.88,1.88,0,0,1-1.44.59A2,2,0,0,1,149.44,246.17Z"
            fill="#263238"
          ></path>
          <path
            d="M155.92,246.31v1.86h-.39v-.47a1.07,1.07,0,0,1-1,.49c-.67,0-1.08-.35-1.08-.87s.29-.85,1.14-.85h.94v-.18a.73.73,0,0,0-.84-.79,1.52,1.52,0,0,0-1,.35l-.18-.3a1.88,1.88,0,0,1,1.2-.4A1.06,1.06,0,0,1,155.92,246.31Zm-.4,1v-.49h-.93c-.57,0-.76.22-.76.53s.28.57.75.57A1,1,0,0,0,155.52,247.27Z"
            fill="#263238"
          ></path>
          <path
            d="M158.49,245.15v.39h-.1c-.62,0-1,.39-1,1.1v1.53H157v-3h.38v.59A1.11,1.11,0,0,1,158.49,245.15Z"
            fill="#263238"
          ></path>
          <path
            d="M161.87,243.94v4.23h-.38v-.6a1.26,1.26,0,0,1-1.14.62,1.52,1.52,0,0,1,0-3,1.28,1.28,0,0,1,1.12.59v-1.8Zm-.39,2.73a1.1,1.1,0,1,0-1.1,1.17A1.09,1.09,0,0,0,161.48,246.67Z"
            fill="#263238"
          ></path>
          <path
            d="M194.25,284.82a6,6,0,0,0,1.75-.38,4.88,4.88,0,0,0,3-3.82,11.34,11.34,0,0,0,.05-1.77c0-.63,0-1.29,0-2,0-1.38,0-2.87,0-4.47s0-3.34-.06-5.12a4.79,4.79,0,0,0-3.43-4,12,12,0,0,0-3-.18h-10.1l-15.16,0-34.73,0a4.69,4.69,0,0,0-3.75,1.88,4.52,4.52,0,0,0-.86,2,14.4,14.4,0,0,0-.09,2.2v8.86c0,.72,0,1.47,0,2.15a4.57,4.57,0,0,0,.59,1.94,4.78,4.78,0,0,0,3.15,2.29,11.23,11.23,0,0,0,2,.1h6.11l28.37.06,19.12.08,5.2,0,1.35,0a3.92,3.92,0,0,1,.46,0s-.15,0-.46,0l-1.35,0-5.2,0-19.12.09-28.37.05h-6.11a11.08,11.08,0,0,1-2.13-.1,5.25,5.25,0,0,1-3.49-2.54,5,5,0,0,1-.66-2.14c0-.76,0-1.45,0-2.19,0-2.9,0-5.86,0-8.86a13.9,13.9,0,0,1,.1-2.3,5,5,0,0,1,.95-2.17,5.25,5.25,0,0,1,4.17-2.08l34.73,0,15.16,0,6.86,0h3.24a11.74,11.74,0,0,1,3.13.21,5.1,5.1,0,0,1,3.65,4.28c.09,1.86,0,3.55,0,5.16s0,3.09,0,4.47c0,.68,0,1.34,0,2a11.82,11.82,0,0,1-.08,1.8,5,5,0,0,1-1.35,2.68,4.8,4.8,0,0,1-1.85,1.21,4.94,4.94,0,0,1-1.33.29Z"
            fill="#263238"
          ></path>
          <path
            d="M270.92,284.82a6.13,6.13,0,0,0,1.76-.38,4.87,4.87,0,0,0,1.77-1.21,4.79,4.79,0,0,0,1.26-2.61,11.34,11.34,0,0,0,.05-1.77c0-.63,0-1.29,0-2,0-1.38,0-2.87,0-4.47s0-3.34-.06-5.12a4.79,4.79,0,0,0-3.43-4,12,12,0,0,0-3-.18h-10.1l-15.16,0-34.73,0a4.69,4.69,0,0,0-3.75,1.88,4.52,4.52,0,0,0-.86,2,14.4,14.4,0,0,0-.09,2.2v8.86c0,.72,0,1.47,0,2.15a4.57,4.57,0,0,0,.59,1.94,4.78,4.78,0,0,0,3.15,2.29,11.23,11.23,0,0,0,2,.1h6.12l28.36.06,19.12.08,5.2,0,1.35,0a3.92,3.92,0,0,1,.46,0s-.15,0-.46,0l-1.35,0-5.2,0-19.12.09-28.36.05h-6.12a11.08,11.08,0,0,1-2.13-.1,5.25,5.25,0,0,1-3.49-2.54,5.1,5.1,0,0,1-.66-2.14c0-.76,0-1.45,0-2.19v-8.86a12.86,12.86,0,0,1,.09-2.3,5.16,5.16,0,0,1,1-2.17,5.25,5.25,0,0,1,4.17-2.08l34.73,0,15.16,0,6.87,0h3.23a11.71,11.71,0,0,1,3.13.21,5.13,5.13,0,0,1,3.66,4.28c.08,1.86,0,3.55,0,5.16s0,3.09,0,4.47c0,.68,0,1.34,0,2a11.82,11.82,0,0,1-.08,1.8,5,5,0,0,1-1.35,2.68,4.8,4.8,0,0,1-1.85,1.21,5,5,0,0,1-1.32.29Z"
            fill="#263238"
          ></path>
          <path
            d="M273.63,141.49c0,.15-32.59.26-72.77.26s-72.78-.11-72.78-.26,32.58-.26,72.78-.26S273.63,141.35,273.63,141.49Z"
            fill="#263238"
          ></path>
          <path
            d="M131.48,187.33c0,.88-.63,1.41-1.68,1.41h-1.1V190h-.44v-4.11h1.54C130.85,185.92,131.48,186.45,131.48,187.33Zm-.43,0c0-.66-.44-1-1.26-1H128.7v2h1.09C130.61,188.35,131.05,188,131.05,187.33Z"
            fill="#263238"
          ></path>
          <path
            d="M134.63,188.12V190h-.4v-.48a1.15,1.15,0,0,1-1.06.51c-.7,0-1.13-.36-1.13-.9s.31-.87,1.19-.87h1v-.19c0-.53-.29-.81-.87-.81a1.59,1.59,0,0,0-1,.36l-.19-.31a2,2,0,0,1,1.26-.42A1.1,1.1,0,0,1,134.63,188.12Zm-.42,1v-.51h-1c-.6,0-.8.24-.8.55s.29.58.78.58A1,1,0,0,0,134.21,189.11Z"
            fill="#263238"
          ></path>
          <path
            d="M135.33,189.68l.19-.33a1.85,1.85,0,0,0,1.1.35c.59,0,.83-.2.83-.51,0-.8-2-.17-2-1.39,0-.5.44-.88,1.23-.88a2.05,2.05,0,0,1,1.09.29l-.18.33a1.66,1.66,0,0,0-.91-.26c-.56,0-.81.22-.81.51,0,.83,2,.21,2,1.39,0,.54-.47.88-1.28.88A2.07,2.07,0,0,1,135.33,189.68Z"
            fill="#263238"
          ></path>
          <path
            d="M138.2,189.68l.19-.33a1.83,1.83,0,0,0,1.1.35c.59,0,.83-.2.83-.51,0-.8-2-.17-2-1.39,0-.5.44-.88,1.23-.88a2.05,2.05,0,0,1,1.09.29l-.18.33a1.66,1.66,0,0,0-.91-.26c-.56,0-.81.22-.81.51,0,.83,2,.21,2,1.39,0,.54-.46.88-1.27.88A2.07,2.07,0,0,1,138.2,189.68Z"
            fill="#263238"
          ></path>
          <path
            d="M146,186.94,144.81,190h-.39l-1-2.53-1,2.53h-.4l-1.16-3.09h.4l1,2.63,1-2.63h.36l1,2.63,1-2.63Z"
            fill="#263238"
          ></path>
          <path
            d="M146.2,188.49a1.57,1.57,0,1,1,1.58,1.57A1.52,1.52,0,0,1,146.2,188.49Zm2.72,0a1.15,1.15,0,1,0-1.14,1.2A1.12,1.12,0,0,0,148.92,188.49Z"
            fill="#263238"
          ></path>
          <path
            d="M151.75,186.92v.41h-.1a1,1,0,0,0-1,1.14V190h-.42v-3.09h.4v.61A1.18,1.18,0,0,1,151.75,186.92Z"
            fill="#263238"
          ></path>
          <path
            d="M155.29,185.67V190h-.4v-.61a1.33,1.33,0,0,1-1.19.64,1.57,1.57,0,0,1,0-3.14,1.35,1.35,0,0,1,1.17.61v-1.86Zm-.41,2.82a1.15,1.15,0,1,0-1.15,1.2A1.13,1.13,0,0,0,154.88,188.49Z"
            fill="#263238"
          ></path>
          <path
            d="M270.56,176.65a7.19,7.19,0,0,0,.82-.13,3.55,3.55,0,0,0,2-1.32,3.45,3.45,0,0,0,.66-1.62c.07-.64,0-1.38,0-2.16,0-1.58,0-3.39,0-5.43,0-1,0-2.1,0-3.24a3.64,3.64,0,0,0-1.2-3.11,3.44,3.44,0,0,0-1.63-.78,15.73,15.73,0,0,0-2-.05H265l-19.71,0-114.14.08a3.3,3.3,0,0,0-3,2,4.53,4.53,0,0,0-.26,1.93V165q0,4.13,0,8.19a3.28,3.28,0,0,0,2,3,4.14,4.14,0,0,0,1.87.28h10l30.31,0,51.32.05,34.59.09,9.41,0,2.44,0,.84,0-.84,0-2.44,0-9.41.05-34.59.08-51.32.06H131.69a4.43,4.43,0,0,1-2.07-.32,3.81,3.81,0,0,1-2.28-3.43c0-2.71,0-5.45,0-8.2v-2.07a9.65,9.65,0,0,1,0-1.06,4.07,4.07,0,0,1,.27-1.08,3.85,3.85,0,0,1,3.53-2.33l114.14.08,19.71,0h4.2a14.8,14.8,0,0,1,2,.07,3.7,3.7,0,0,1,1.76.84,3.86,3.86,0,0,1,1.25,3.3c0,1.14,0,2.22,0,3.24,0,2,0,3.85,0,5.43,0,.79,0,1.5-.05,2.18a3.64,3.64,0,0,1-.71,1.67,3.55,3.55,0,0,1-2,1.3A3.07,3.07,0,0,1,270.56,176.65Z"
            fill="#263238"
          ></path>
          <path
            d="M131.17,155.56v.38h-2.91v-4.12h2.82v.38H128.7v1.46h2.12V154H128.7v1.53Z"
            fill="#263238"
          ></path>
          <path
            d="M137.2,154.14v1.8h-.42v-1.76c0-.65-.33-1-.89-1a1,1,0,0,0-1,1.11v1.63h-.42v-1.76c0-.65-.33-1-.89-1a1,1,0,0,0-1,1.11v1.63h-.42v-3.09h.4v.56a1.26,1.26,0,0,1,1.13-.59,1.12,1.12,0,0,1,1.1.65,1.35,1.35,0,0,1,1.22-.65A1.17,1.17,0,0,1,137.2,154.14Z"
            fill="#263238"
          ></path>
          <path
            d="M140.66,154v1.92h-.4v-.49a1.16,1.16,0,0,1-1.06.52c-.7,0-1.13-.37-1.13-.9s.3-.88,1.19-.88h1V154c0-.53-.3-.81-.87-.81a1.59,1.59,0,0,0-1,.36l-.19-.31a1.93,1.93,0,0,1,1.26-.42A1.1,1.1,0,0,1,140.66,154Zm-.42,1v-.51h-1c-.6,0-.79.24-.79.56s.29.58.78.58A1,1,0,0,0,140.24,155Z"
            fill="#263238"
          ></path>
          <path
            d="M141.69,151.87a.31.31,0,1,1,.31.3A.3.3,0,0,1,141.69,151.87Zm.1,1h.42v3.09h-.42Z"
            fill="#263238"
          ></path>
          <path d="M143.37,151.58h.41v4.36h-.41Z" fill="#263238"></path>
          <path
            d="M270.56,214.53a7.19,7.19,0,0,0,.82-.13,3.55,3.55,0,0,0,2-1.32,3.45,3.45,0,0,0,.66-1.62c.07-.64,0-1.38,0-2.16,0-1.58,0-3.39,0-5.43,0-1,0-2.1,0-3.24a3.63,3.63,0,0,0-1.2-3.11,3.44,3.44,0,0,0-1.63-.78,15.73,15.73,0,0,0-2-.05H265l-19.71,0-114.14.08a3.3,3.3,0,0,0-3,2,4.53,4.53,0,0,0-.26,1.93v2.07q0,4.13,0,8.19a3.28,3.28,0,0,0,2,3,4.14,4.14,0,0,0,1.87.28h10l30.31,0,51.32.05,34.59.08,9.41.05,2.44,0,.84,0-.84,0-2.44,0-9.41,0-34.59.08-51.32.06H131.69a4.43,4.43,0,0,1-2.07-.32,3.81,3.81,0,0,1-2.28-3.43c0-2.71,0-5.45,0-8.2v-2.07a9.65,9.65,0,0,1,0-1.06,4.07,4.07,0,0,1,.27-1.08,3.85,3.85,0,0,1,3.53-2.33l114.14.08,19.71,0h4.2a14.8,14.8,0,0,1,2,.07,3.7,3.7,0,0,1,1.76.84,3.86,3.86,0,0,1,1.25,3.3c0,1.14,0,2.22,0,3.24,0,2,0,3.85,0,5.43,0,.79,0,1.5-.05,2.18a3.64,3.64,0,0,1-.71,1.67,3.55,3.55,0,0,1-2,1.3A3.07,3.07,0,0,1,270.56,214.53Z"
            fill="#263238"
          ></path>
          <path
            d="M140,205.57a1.67,1.67,0,1,1-1.67-1.67A1.67,1.67,0,0,1,140,205.57Z"
            fill="#263238"
          ></path>
          <circle cx="146.06" cy="205.57" r="1.67" fill="#263238"></circle>
          <circle cx="153.75" cy="205.57" r="1.67" fill="#263238"></circle>
          <path
            d="M163.11,205.57a1.67,1.67,0,1,1-1.67-1.67A1.67,1.67,0,0,1,163.11,205.57Z"
            fill="#263238"
          ></path>
          <path
            d="M170.8,205.57a1.67,1.67,0,1,1-1.67-1.67A1.67,1.67,0,0,1,170.8,205.57Z"
            fill="#263238"
          ></path>
          <path
            d="M178.49,205.57a1.67,1.67,0,1,1-1.67-1.67A1.67,1.67,0,0,1,178.49,205.57Z"
            fill="#263238"
          ></path>
          <path
            d="M186.18,205.57a1.67,1.67,0,1,1-1.67-1.67A1.67,1.67,0,0,1,186.18,205.57Z"
            fill="#263238"
          ></path>
          <path
            d="M193.87,205.57a1.67,1.67,0,1,1-1.67-1.67A1.67,1.67,0,0,1,193.87,205.57Z"
            fill="#263238"
          ></path>
          <circle cx="199.89" cy="205.57" r="1.67" fill="#263238"></circle>
          <path
            d="M210.66,205.57A1.67,1.67,0,1,1,209,203.9,1.67,1.67,0,0,1,210.66,205.57Z"
            fill="#263238"
          ></path>
          <path
            d="M270.56,254.66a7.19,7.19,0,0,0,.82-.13,3.55,3.55,0,0,0,2-1.32,3.45,3.45,0,0,0,.66-1.62c.07-.64,0-1.38,0-2.16,0-1.58,0-3.39,0-5.43,0-1,0-2.1,0-3.23a3.65,3.65,0,0,0-1.2-3.12,3.44,3.44,0,0,0-1.63-.78,17.92,17.92,0,0,0-2-.05H265l-19.71,0L131.16,237a3.3,3.3,0,0,0-3,2,4.53,4.53,0,0,0-.26,1.93V243q0,4.13,0,8.2a3.28,3.28,0,0,0,2,3,4.14,4.14,0,0,0,1.87.28h10l30.31,0,51.32.05,34.59.09,9.41.05,2.44,0,.84,0-.84,0-2.44,0-9.41,0-34.59.08L172,254.9H131.69a4.57,4.57,0,0,1-2.07-.33,3.79,3.79,0,0,1-2.28-3.43c0-2.71,0-5.45,0-8.2v-2.07a9.65,9.65,0,0,1,0-1.06,4.07,4.07,0,0,1,.27-1.08,3.84,3.84,0,0,1,3.53-2.32l114.14.07,19.71,0h4.2a14.8,14.8,0,0,1,2,.07,3.63,3.63,0,0,1,1.76.85,3.84,3.84,0,0,1,1.25,3.3c0,1.13,0,2.21,0,3.23,0,2,0,3.85,0,5.43,0,.79,0,1.5-.05,2.18a3.64,3.64,0,0,1-.71,1.67,3.5,3.5,0,0,1-2,1.3A2.62,2.62,0,0,1,270.56,254.66Z"
            fill="#263238"
          ></path>
          <path
            d="M185,247.33H184v1.22h-.68v-1.22h-2.76v-.49l2.54-3.25h.76l-2.43,3.13h1.91v-1.07H184v1.07H185Z"
            fill="#263238"
          ></path>
          <path
            d="M189.14,247.06c0,.86-.61,1.55-1.88,1.55a2.83,2.83,0,0,1-1.82-.61l.33-.56a2.17,2.17,0,0,0,1.48.54c.75,0,1.18-.35,1.18-.89s-.35-.91-1.5-.91H185.8l.26-2.59h2.8v.62h-2.2l-.14,1.36h.56C188.56,245.57,189.14,246.18,189.14,247.06Z"
            fill="#263238"
          ></path>
          <path
            d="M193.45,247.06c0,.86-.61,1.55-1.88,1.55a2.83,2.83,0,0,1-1.82-.61l.33-.56a2.17,2.17,0,0,0,1.48.54c.75,0,1.18-.35,1.18-.89s-.36-.91-1.5-.91h-1.13l.26-2.59h2.8v.62H191l-.14,1.36h.56C192.87,245.57,193.45,246.18,193.45,247.06Z"
            fill="#263238"
          ></path>
          <path
            d="M197.76,247.06c0,.86-.61,1.55-1.88,1.55a2.83,2.83,0,0,1-1.82-.61l.33-.56a2.17,2.17,0,0,0,1.48.54c.75,0,1.18-.35,1.18-.89s-.35-.91-1.5-.91h-1.13l.26-2.59h2.8v.62h-2.2l-.14,1.36h.56C197.18,245.57,197.76,246.18,197.76,247.06Z"
            fill="#263238"
          ></path>
          <path
            d="M200.81,246.07c0-1.61.87-2.53,2-2.53s2,.92,2,2.53-.87,2.54-2,2.54S200.81,247.69,200.81,246.07Zm3.34,0c0-1.27-.54-1.9-1.31-1.9s-1.32.63-1.32,1.9.54,1.91,1.32,1.91S204.15,247.34,204.15,246.07Z"
            fill="#263238"
          ></path>
          <path
            d="M205.82,246.07c0-1.61.86-2.53,2-2.53s2,.92,2,2.53-.86,2.54-2,2.54S205.82,247.69,205.82,246.07Zm3.33,0c0-1.27-.54-1.9-1.31-1.9s-1.32.63-1.32,1.9.54,1.91,1.32,1.91S209.15,247.34,209.15,246.07Z"
            fill="#263238"
          ></path>
          <path
            d="M210.82,246.07c0-1.61.86-2.53,2-2.53s2,.92,2,2.53-.86,2.54-2,2.54S210.82,247.69,210.82,246.07Zm3.34,0c0-1.27-.54-1.9-1.31-1.9s-1.32.63-1.32,1.9.54,1.91,1.32,1.91S214.16,247.34,214.16,246.07Z"
            fill="#263238"
          ></path>
          <path
            d="M215.82,246.07c0-1.61.87-2.53,2-2.53s2,.92,2,2.53-.87,2.54-2,2.54S215.82,247.69,215.82,246.07Zm3.34,0c0-1.27-.54-1.9-1.31-1.9s-1.32.63-1.32,1.9.54,1.91,1.32,1.91S219.16,247.34,219.16,246.07Z"
            fill="#263238"
          ></path>
          <path
            d="M226.63,243.59v.48l-2,4.48h-.75l2-4.34h-2.26v.88h-.68v-1.5Z"
            fill="#263238"
          ></path>
          <path
            d="M231.14,243.59v.48l-2,4.48h-.75l2-4.34h-2.27v.88h-.68v-1.5Z"
            fill="#263238"
          ></path>
          <path
            d="M235.66,243.59v.48l-2,4.48h-.75l2-4.34H232.6v.88h-.68v-1.5Z"
            fill="#263238"
          ></path>
          <path
            d="M240.17,243.59v.48l-2,4.48h-.75l2-4.34h-2.27v.88h-.68v-1.5Z"
            fill="#263238"
          ></path>
          <path
            d="M247.1,247a1.61,1.61,0,0,1-1.76,1.57c-1.33,0-2.08-.9-2.08-2.48a2.28,2.28,0,0,1,2.35-2.59,2.38,2.38,0,0,1,1.23.29l-.27.55a1.74,1.74,0,0,0-.95-.23c-1,0-1.65.63-1.65,1.86a1.09,1.09,0,0,0,0,.18,1.65,1.65,0,0,1,1.42-.65A1.54,1.54,0,0,1,247.1,247Zm-.69,0c0-.58-.44-1-1.13-1a1,1,0,0,0-1.14,1c0,.51.41.95,1.18.95A1,1,0,0,0,246.41,247.07Z"
            fill="#263238"
          ></path>
          <path
            d="M251.75,247a1.61,1.61,0,0,1-1.76,1.57c-1.33,0-2.08-.9-2.08-2.48a2.28,2.28,0,0,1,2.34-2.59,2.4,2.4,0,0,1,1.24.29l-.27.55a1.74,1.74,0,0,0-.95-.23c-1,0-1.65.63-1.65,1.86a1.09,1.09,0,0,0,0,.18,1.65,1.65,0,0,1,1.42-.65A1.54,1.54,0,0,1,251.75,247Zm-.69,0c0-.58-.44-1-1.13-1a1,1,0,0,0-1.14,1c0,.51.41.95,1.17.95A1,1,0,0,0,251.06,247.07Z"
            fill="#263238"
          ></path>
          <path
            d="M256.4,247a1.61,1.61,0,0,1-1.76,1.57c-1.33,0-2.08-.9-2.08-2.48a2.28,2.28,0,0,1,2.35-2.59,2.38,2.38,0,0,1,1.23.29l-.27.55a1.74,1.74,0,0,0-1-.23c-1,0-1.65.63-1.65,1.86a1.09,1.09,0,0,0,0,.18,1.65,1.65,0,0,1,1.42-.65A1.54,1.54,0,0,1,256.4,247Zm-.69,0c0-.58-.44-1-1.13-1a1,1,0,0,0-1.14,1c0,.51.41.95,1.17.95A1,1,0,0,0,255.71,247.07Z"
            fill="#263238"
          ></path>
          <path
            d="M261.05,247a1.61,1.61,0,0,1-1.76,1.57c-1.33,0-2.08-.9-2.08-2.48a2.28,2.28,0,0,1,2.34-2.59,2.4,2.4,0,0,1,1.24.29l-.27.55a1.74,1.74,0,0,0-.95-.23c-1,0-1.65.63-1.65,1.86a1.09,1.09,0,0,0,0,.18,1.65,1.65,0,0,1,1.42-.65A1.54,1.54,0,0,1,261.05,247Zm-.69,0c0-.58-.44-1-1.13-1a1,1,0,0,0-1.14,1c0,.51.41.95,1.17.95A1,1,0,0,0,260.36,247.07Z"
            fill="#263238"
          ></path>
          <path
            d="M137.63,166.06l-1.82,4.13c-.34.79-.77,1-1.34,1a1.38,1.38,0,0,1-1-.35l.29-.51a.93.93,0,0,0,.67.28c.32,0,.53-.15.71-.58l.12-.26-1.65-3.75h.7l1.32,3,1.29-3Z"
            fill="#263238"
          ></path>
          <path
            d="M138.09,167.94a2,2,0,1,1,2,1.92A1.88,1.88,0,0,1,138.09,167.94Zm3.22,0a1.27,1.27,0,1,0-1.26,1.32A1.23,1.23,0,0,0,141.31,167.94Z"
            fill="#263238"
          ></path>
          <path
            d="M146.71,166.06v3.75h-.64v-.56a1.53,1.53,0,0,1-1.28.61,1.48,1.48,0,0,1-1.61-1.64v-2.16h.68v2.08c0,.74.37,1.11,1,1.11A1.1,1.1,0,0,0,146,168v-1.94Z"
            fill="#263238"
          ></path>
          <path
            d="M150.31,166v.66h-.16a1.11,1.11,0,0,0-1.18,1.26v1.87h-.68v-3.75h.65v.63A1.44,1.44,0,0,1,150.31,166Z"
            fill="#263238"
          ></path>
          <path
            d="M154.77,168.16h-3.05a1.28,1.28,0,0,0,1.36,1.1,1.43,1.43,0,0,0,1.09-.45l.37.44a1.91,1.91,0,0,1-1.48.61,1.88,1.88,0,0,1-2-1.92,1.85,1.85,0,0,1,1.89-1.92,1.81,1.81,0,0,1,1.85,1.94S154.77,168.1,154.77,168.16Zm-3.05-.49h2.41a1.21,1.21,0,0,0-2.41,0Z"
            fill="#263238"
          ></path>
          <path
            d="M162.23,167.65v2.16h-.68v-2.08c0-.74-.35-1.1-1-1.1a1.1,1.1,0,0,0-1.12,1.25v1.93h-.68v-2.08c0-.74-.35-1.1-1-1.1a1.1,1.1,0,0,0-1.13,1.25v1.93H156v-3.75h.66v.56A1.5,1.5,0,0,1,158,166a1.38,1.38,0,0,1,1.3.7,1.7,1.7,0,0,1,1.45-.7A1.44,1.44,0,0,1,162.23,167.65Z"
            fill="#263238"
          ></path>
          <path
            d="M166.74,167.55v2.26h-.64v-.49a1.4,1.4,0,0,1-1.23.54c-.85,0-1.39-.46-1.39-1.11s.39-1.1,1.51-1.1h1.07v-.13c0-.57-.33-.91-1-.91a1.88,1.88,0,0,0-1.19.41l-.29-.51a2.45,2.45,0,0,1,1.55-.49A1.4,1.4,0,0,1,166.74,167.55Zm-.68,1.12v-.53H165c-.67,0-.86.26-.86.58s.31.61.83.61A1.08,1.08,0,0,0,166.06,168.67Z"
            fill="#263238"
          ></path>
          <path
            d="M168.16,164.9a.45.45,0,0,1,.46-.45.45.45,0,1,1-.46.45Zm.12,1.16H169v3.75h-.68Z"
            fill="#263238"
          ></path>
          <path d="M170.54,164.56h.68v5.25h-.68Z" fill="#263238"></path>
          <path
            d="M179.13,167.92c0,1.2-.46,1.94-1.26,1.94a.81.81,0,0,1-.85-.68,1.51,1.51,0,0,1-1.34.68,1.82,1.82,0,0,1,0-3.63,1.57,1.57,0,0,1,1.3.6v-.57h.61v2.55c0,.37.19.51.41.51.41,0,.65-.51.65-1.4a2.6,2.6,0,0,0-2.81-2.65,2.75,2.75,0,1,0,0,5.5,3,3,0,0,0,1.36-.31l.16.45a3.55,3.55,0,0,1-1.52.33,3.22,3.22,0,1,1,0-6.43A3.06,3.06,0,0,1,179.13,167.92ZM177,168a1.17,1.17,0,0,0-1.21-1.26,1.26,1.26,0,0,0,0,2.52A1.17,1.17,0,0,0,177,168Z"
            fill="#263238"
          ></path>
          <path
            d="M183.78,168.16h-3.05a1.28,1.28,0,0,0,1.36,1.1,1.4,1.4,0,0,0,1.08-.45l.38.44a1.91,1.91,0,0,1-1.48.61,1.88,1.88,0,0,1-2-1.92,1.85,1.85,0,0,1,1.89-1.92,1.81,1.81,0,0,1,1.85,1.94S183.78,168.1,183.78,168.16Zm-3.05-.49h2.41a1.21,1.21,0,0,0-2.41,0Z"
            fill="#263238"
          ></path>
          <path
            d="M191.24,167.65v2.16h-.68v-2.08c0-.74-.35-1.1-1-1.1s-1.12.44-1.12,1.25v1.93h-.68v-2.08c0-.74-.36-1.1-1-1.1a1.1,1.1,0,0,0-1.13,1.25v1.93H185v-3.75h.66v.56A1.5,1.5,0,0,1,187,166a1.38,1.38,0,0,1,1.3.7,1.7,1.7,0,0,1,1.45-.7A1.44,1.44,0,0,1,191.24,167.65Z"
            fill="#263238"
          ></path>
          <path
            d="M195.75,167.55v2.26h-.64v-.49a1.41,1.41,0,0,1-1.24.54c-.85,0-1.38-.46-1.38-1.11s.39-1.1,1.51-1.1h1.07v-.13c0-.57-.33-.91-1-.91a1.88,1.88,0,0,0-1.19.41l-.29-.51a2.45,2.45,0,0,1,1.55-.49A1.4,1.4,0,0,1,195.75,167.55Zm-.68,1.12v-.53h-1c-.67,0-.86.26-.86.58s.31.61.83.61A1.08,1.08,0,0,0,195.07,168.67Z"
            fill="#263238"
          ></path>
          <path
            d="M197.17,164.9a.45.45,0,0,1,.46-.45.45.45,0,1,1-.46.45Zm.12,1.16H198v3.75h-.68Z"
            fill="#263238"
          ></path>
          <path d="M199.55,164.56h.68v5.25h-.68Z" fill="#263238"></path>
          <path
            d="M201.49,169.37a.47.47,0,0,1,.48-.48.46.46,0,0,1,.47.48.47.47,0,0,1-.47.49A.48.48,0,0,1,201.49,169.37Z"
            fill="#263238"
          ></path>
          <path
            d="M203.27,167.94a1.88,1.88,0,0,1,2-1.92,1.68,1.68,0,0,1,1.53.81l-.52.33a1.17,1.17,0,0,0-1-.54,1.32,1.32,0,0,0,0,2.64,1.17,1.17,0,0,0,1-.54l.52.33a1.7,1.7,0,0,1-1.53.81A1.88,1.88,0,0,1,203.27,167.94Z"
            fill="#263238"
          ></path>
          <path
            d="M207.53,167.94a2,2,0,1,1,2,1.92A1.88,1.88,0,0,1,207.53,167.94Zm3.22,0a1.27,1.27,0,1,0-1.26,1.32A1.23,1.23,0,0,0,210.75,167.94Z"
            fill="#263238"
          ></path>
          <path
            d="M218.89,167.65v2.16h-.68v-2.08c0-.74-.36-1.1-1-1.1a1.1,1.1,0,0,0-1.13,1.25v1.93h-.68v-2.08c0-.74-.35-1.1-1-1.1s-1.12.44-1.12,1.25v1.93h-.68v-3.75h.65v.56a1.53,1.53,0,0,1,1.29-.6,1.4,1.4,0,0,1,1.31.7,1.67,1.67,0,0,1,1.44-.7A1.45,1.45,0,0,1,218.89,167.65Z"
            fill="#263238"
          ></path>
          <path
            d="M137.18,270.88v.52h-3v-4.2h3v.52h-2.37V269h2.11v.51h-2.11v1.36Z"
            fill="#263238"
          ></path>
          <path
            d="M139.91,271.4l-.92-1.22-.93,1.22h-.64l1.25-1.62-1.19-1.56h.64l.87,1.15.87-1.15h.63l-1.2,1.56,1.27,1.62Z"
            fill="#263238"
          ></path>
          <path
            d="M144.36,269.81a1.54,1.54,0,0,1-1.6,1.63,1.36,1.36,0,0,1-1.11-.52v1.64h-.58v-4.34h.55v.51a1.35,1.35,0,0,1,1.14-.54A1.54,1.54,0,0,1,144.36,269.81Zm-.58,0a1.07,1.07,0,1,0-1.07,1.12A1,1,0,0,0,143.78,269.81Z"
            fill="#263238"
          ></path>
          <path
            d="M144.94,267.24a.38.38,0,0,1,.39-.38.38.38,0,1,1-.39.38Zm.1,1h.58v3.18H145Z"
            fill="#263238"
          ></path>
          <path
            d="M148.31,268.19v.56h-.14a1,1,0,0,0-1,1.08v1.58h-.57v-3.18h.55v.54A1.2,1.2,0,0,1,148.31,268.19Z"
            fill="#263238"
          ></path>
          <path
            d="M151.41,269.48v1.92h-.55V271a1.17,1.17,0,0,1-1,.46c-.72,0-1.18-.39-1.18-.94s.33-.93,1.28-.93h.91v-.11c0-.49-.28-.77-.85-.77a1.62,1.62,0,0,0-1,.34l-.24-.43a2.16,2.16,0,0,1,1.32-.41C150.92,268.19,151.41,268.61,151.41,269.48Zm-.58.95V270h-.89c-.57,0-.73.22-.73.49s.27.51.7.51A.91.91,0,0,0,150.83,270.43Z"
            fill="#263238"
          ></path>
          <path
            d="M154.14,271.22a1.12,1.12,0,0,1-.69.22.91.91,0,0,1-1-1V268.7h-.54v-.48h.54v-.69H153v.69h.91v.48H153v1.72a.46.46,0,0,0,.49.53.7.7,0,0,0,.45-.15Z"
            fill="#263238"
          ></path>
          <path
            d="M154.62,267.24a.38.38,0,0,1,.39-.38.38.38,0,1,1-.39.38Zm.1,1h.58v3.18h-.58Z"
            fill="#263238"
          ></path>
          <path
            d="M156,269.81a1.66,1.66,0,1,1,1.66,1.63A1.58,1.58,0,0,1,156,269.81Zm2.72,0a1.07,1.07,0,1,0-2.14,0,1.07,1.07,0,1,0,2.14,0Z"
            fill="#263238"
          ></path>
          <path
            d="M163,269.57v1.83h-.57v-1.76c0-.63-.32-.93-.86-.93a.94.94,0,0,0-1,1.05v1.64H160v-3.18h.56v.48a1.36,1.36,0,0,1,1.14-.51A1.23,1.23,0,0,1,163,269.57Z"
            fill="#263238"
          ></path>
          <path
            d="M165.51,267.2h1.77a2.11,2.11,0,1,1,0,4.2h-1.77Zm1.73,3.68a1.58,1.58,0,1,0,0-3.16h-1.13v3.16Z"
            fill="#263238"
          ></path>
          <path
            d="M172.78,269.48v1.92h-.55V271a1.17,1.17,0,0,1-1,.46c-.72,0-1.18-.39-1.18-.94s.33-.93,1.28-.93h.91v-.11c0-.49-.28-.77-.85-.77a1.62,1.62,0,0,0-1,.34l-.24-.43a2.16,2.16,0,0,1,1.32-.41C172.29,268.19,172.78,268.61,172.78,269.48Zm-.58.95V270h-.88c-.57,0-.74.22-.74.49s.27.51.71.51A.9.9,0,0,0,172.2,270.43Z"
            fill="#263238"
          ></path>
          <path
            d="M176.48,268.22l-1.54,3.5c-.28.67-.65.88-1.13.88a1.21,1.21,0,0,1-.82-.29l.25-.44a.8.8,0,0,0,.57.24c.27,0,.45-.13.6-.49l.1-.23-1.4-3.17h.6l1.11,2.54,1.1-2.54Z"
            fill="#263238"
          ></path>
          <path
            d="M209.94,269.81a1.59,1.59,0,0,1,1.68-1.62,1.42,1.42,0,0,1,1.29.68l-.43.28a1,1,0,0,0-.87-.45,1.12,1.12,0,0,0,0,2.23,1,1,0,0,0,.87-.45l.43.27a1.4,1.4,0,0,1-1.29.69A1.59,1.59,0,0,1,209.94,269.81Z"
            fill="#263238"
          ></path>
          <path
            d="M216.31,268.22l-1.39,3.18h-.59l-1.39-3.18h.6l1.09,2.55,1.12-2.55Z"
            fill="#263238"
          ></path>
          <path
            d="M219.5,268.22l-1.4,3.18h-.58l-1.39-3.18h.6l1.09,2.55,1.11-2.55Z"
            fill="#263238"
          ></path>
          <path
            d="M136.09,276.23v4.2h-.59v-3.67h-.95v-.53Z"
            fill="#263238"
          ></path>
          <path
            d="M139.84,279.91v.52h-3V280l1.71-1.65c.44-.43.52-.69.52-.95,0-.44-.3-.7-.89-.7a1.29,1.29,0,0,0-1.07.46l-.41-.36a1.93,1.93,0,0,1,1.53-.63c.88,0,1.44.45,1.44,1.16a1.69,1.69,0,0,1-.69,1.32l-1.28,1.24Z"
            fill="#263238"
          ></path>
          <path d="M143.23,275.38h.53l-2,5.65h-.52Z" fill="#263238"></path>
          <path
            d="M148.07,279.2c0,.7-.52,1.28-1.59,1.28a2.36,2.36,0,0,1-1.54-.51l.27-.47a1.93,1.93,0,0,0,1.27.45c.63,0,1-.29,1-.75s-.32-.73-1-.73h-.33v-.42l1.05-1.29h-2v-.53h2.77v.41L146.8,278C147.64,278.07,148.07,278.55,148.07,279.2Z"
            fill="#263238"
          ></path>
          <path
            d="M148.51,278.33c0-1.36.73-2.14,1.71-2.14s1.71.78,1.71,2.14-.73,2.15-1.71,2.15S148.51,279.7,148.51,278.33Zm2.82,0c0-1.07-.45-1.61-1.11-1.61s-1.11.54-1.11,1.61.45,1.62,1.11,1.62S151.33,279.41,151.33,278.33Z"
            fill="#263238"
          ></path>
          <path
            d="M210,278.33c0-1.36.73-2.14,1.71-2.14s1.71.78,1.71,2.14-.73,2.15-1.71,2.15S210,279.7,210,278.33Zm2.82,0c0-1.07-.46-1.61-1.11-1.61s-1.11.54-1.11,1.61S211,280,211.69,280,212.8,279.41,212.8,278.33Z"
            fill="#263238"
          ></path>
          <path
            d="M213.86,278.33c0-1.36.73-2.14,1.71-2.14s1.71.78,1.71,2.14-.73,2.15-1.71,2.15S213.86,279.7,213.86,278.33Zm2.82,0c0-1.07-.45-1.61-1.11-1.61s-1.11.54-1.11,1.61.45,1.62,1.11,1.62S216.68,279.41,216.68,278.33Z"
            fill="#263238"
          ></path>
          <path
            d="M217.74,278.33c0-1.36.73-2.14,1.71-2.14s1.71.78,1.71,2.14-.73,2.15-1.71,2.15S217.74,279.7,217.74,278.33Zm2.82,0c0-1.07-.45-1.61-1.11-1.61s-1.11.54-1.11,1.61.45,1.62,1.11,1.62S220.56,279.41,220.56,278.33Z"
            fill="#263238"
          ></path>
          <path
            d="M178.32,88.59c0,1.64-1.21,2.65-3.17,2.65h-1.68v2.15h-1.38V85.94h3.06C177.11,85.94,178.32,86.94,178.32,88.59Zm-1.4,0c0-.94-.62-1.48-1.84-1.48h-1.61v3h1.61C176.3,90.07,176.92,89.53,176.92,88.59Z"
            fill="#263238"
          ></path>
          <path
            d="M184.15,91.66h-3.72l-.73,1.73h-1.43l3.35-7.45H183l3.36,7.45H184.9Zm-.45-1.08-1.41-3.26-1.39,3.26Z"
            fill="#263238"
          ></path>
          <path
            d="M190.05,90.76v2.63h-1.38V90.78l-2.93-4.84h1.48l2.18,3.63,2.2-3.63H193Z"
            fill="#263238"
          ></path>
          <path
            d="M200.6,93.39V88.45l-2.45,4.09h-.62l-2.44-4v4.87h-1.32V85.94h1.14l2.95,4.94,2.91-4.94h1.14v7.45Z"
            fill="#263238"
          ></path>
          <path
            d="M209.49,92.23v1.16h-5.58V85.94h5.43V87.1h-4.05V89h3.6v1.13h-3.6v2.06Z"
            fill="#263238"
          ></path>
          <path
            d="M217.65,85.94v7.45h-1.14l-4.11-5v5H211V85.94h1.14l4.11,5v-5Z"
            fill="#263238"
          ></path>
          <path
            d="M221.15,87.11h-2.47V85.94H225v1.17h-2.47v6.28h-1.38Z"
            fill="#263238"
          ></path>
          <path
            d="M225.34,92.6l.48-1.07a4.15,4.15,0,0,0,2.45.81c1.16,0,1.65-.41,1.65-1,0-1.61-4.42-.56-4.42-3.32,0-1.2,1-2.22,3-2.22a4.77,4.77,0,0,1,2.48.65l-.44,1.08a4.17,4.17,0,0,0-2-.59c-1.15,0-1.62.45-1.62,1,0,1.59,4.41.56,4.41,3.29,0,1.19-1,2.21-3,2.21A4.82,4.82,0,0,1,225.34,92.6Z"
            fill="#263238"
          ></path>
        </g>
        <g id="freepik--Character--inject-66">
          <path
            d="M301.59,328.78s-9.77-9.11-11.59-9.66-16.18-.35-17.13.39-15.21,9.2-12.76,10.34,12.33-4.9,12.33-4.9l1.7.17s-8.63,5-10.14,6.84.06,3.66,1.68,2.84,9-5.42,9.61-5.27-7.86,5.48-8.63,6.44c-1,1.29-.25,3.7,1.38,2.94,1-.44,8.75-6,8.75-6s-5.85,5.26-6.25,6.1c-.66,1.38.73,2.56,2.09,1.66.93-.61,4.89-4.77,6.14-5.59,0,0,1.41-.15,3.55,2s18.18,9.35,18.18,9.35Z"
            fill="#ffbe9d"
          ></path>
          <path
            d="M298.16,330.27c-.6,1.22-2.21,1.59-3.54,1.35s-2.56-.92-3.88-1.25c-3.94-1-8.21,1.22-12.09,0-.55-.17-1.16-.54-1.12-1.11s.63-.8,1.12-1l12.69-4.5"
            fill="#ffbe9d"
          ></path>
          <path
            d="M291.34,323.82a5.54,5.54,0,0,0-1.43.35c-.89.27-2.19.68-3.78,1.21l-5.57,1.89-1.61.56c-.5.22-1.24.28-1.7,1.09a1.14,1.14,0,0,0,.24,1.25,2.45,2.45,0,0,0,.94.57,8.83,8.83,0,0,0,1.95.37c2.67.18,5.06-.51,7.23-.63a10.3,10.3,0,0,1,3,.19c.92.22,1.76.59,2.57.85a4.76,4.76,0,0,0,4-.1c.86-.54,1-1.16.94-1.15a3.68,3.68,0,0,1-1.08.88,4.58,4.58,0,0,1-3.69-.14,26.9,26.9,0,0,0-2.6-1,10.58,10.58,0,0,0-3.22-.28c-2.26.09-4.66.75-7.12.57a7.71,7.71,0,0,1-1.77-.32c-.53-.17-.9-.54-.74-.8s.71-.51,1.25-.7l1.6-.58,5.52-2.05c1.57-.59,2.84-1.08,3.7-1.44A5.83,5.83,0,0,0,291.34,323.82Z"
            fill="#eb996e"
          ></path>
          <path
            d="M260.15,329.88a7.78,7.78,0,0,0,3.08-.3,17.05,17.05,0,0,0,3.19-1.07c1.12-.58,2.32-1.24,3.59-1.94l2.69-1.51-.18.05c4.28-.09,7.37-.28,7.37-.45s-3.09-.28-7.38-.28h-.09l-.09.05-2.68,1.46-3.52,2a23.2,23.2,0,0,1-3,1.19C261.3,329.6,260.14,329.76,260.15,329.88Z"
            fill="#eb996e"
          ></path>
          <polygon
            points="407.85 298.67 342.09 326.03 301.59 326.03 301.59 339.09 354.72 346.95 402.38 317.25 407.85 298.67"
            fill="#5A9ED1"
          ></polygon>
          <g opacity="0.30000000000000004">
            <polygon points="407.85 298.67 342.09 326.03 301.59 326.03 301.59 339.09 354.72 346.95 402.38 317.25 407.85 298.67"></polygon>
          </g>
          <path
            d="M362.52,339.69a1.46,1.46,0,0,1-.73-.46,4,4,0,0,1-1-2.11,23.2,23.2,0,0,1-.1-3.42,16.59,16.59,0,0,0-.57-4.05,17.62,17.62,0,0,0-3.4-6.59c-1.22-1.49-2.19-2.21-2.12-2.29a3.12,3.12,0,0,1,.71.47,13,13,0,0,1,1.69,1.58,16.22,16.22,0,0,1,3.62,6.69,15.79,15.79,0,0,1,.55,4.19,27.1,27.1,0,0,0,0,3.37,4.1,4.1,0,0,0,.81,2C362.28,339.5,362.54,339.65,362.52,339.69Z"
            fill="#fafafa"
          ></path>
          <path
            d="M386.66,325.41a7.93,7.93,0,0,1-2.33-1,21.41,21.41,0,0,1-4.86-3.79,21.78,21.78,0,0,1-3.6-5,8.05,8.05,0,0,1-.94-2.37,34.17,34.17,0,0,0,4.92,7A34.6,34.6,0,0,0,386.66,325.41Z"
            fill="#fafafa"
          ></path>
          <path
            d="M345.92,345a6.29,6.29,0,0,0,.92-2.69,7.78,7.78,0,0,0-.41-3,17.87,17.87,0,0,0-1.69-3.44,25.33,25.33,0,0,1-1.81-3.49,8.78,8.78,0,0,1-.63-3.18,5.44,5.44,0,0,1,.45-2.14c.22-.47.42-.68.44-.66a7.18,7.18,0,0,0-.52,2.8,9,9,0,0,0,.71,3,27.88,27.88,0,0,0,1.81,3.41,17.12,17.12,0,0,1,1.7,3.55,7.82,7.82,0,0,1,.32,3.23,4.9,4.9,0,0,1-.74,2.06A1.79,1.79,0,0,1,345.92,345Z"
            fill="#fafafa"
          ></path>
          <path
            d="M321.53,338.15a11.14,11.14,0,0,1-1.19-6,11,11,0,0,1,1.66-5.85,19.73,19.73,0,0,0-.47,11.81Z"
            fill="#fafafa"
          ></path>
          <path
            d="M279.85,414.09l-16.43,21.64S235.9,426.3,232.48,430l40.81,33.37,27-32.67Z"
            fill="#455a64"
          ></path>
          <path
            d="M277.48,444.28a2.14,2.14,0,0,1-.4,2.84,2.07,2.07,0,0,1-2.82-.37,2.27,2.27,0,0,1,.44-3,2.15,2.15,0,0,1,2.89.71"
            fill="#e0e0e0"
          ></path>
          <path
            d="M273.29,463.37l2.68-3.25-40.19-30.87s-2.46-.69-3.3.75Z"
            fill="#e0e0e0"
          ></path>
          <path
            d="M262.92,435c-.15.21.77,1.11,1.23,2.56s.29,2.7.54,2.77.89-1.32.31-3.06S263,434.76,262.92,435Z"
            fill="#263238"
          ></path>
          <path
            d="M257.2,433.25c-.21.16.38,1.2.37,2.6s-.55,2.45-.34,2.6,1.25-.87,1.23-2.6S257.36,433.07,257.2,433.25Z"
            fill="#263238"
          ></path>
          <path
            d="M250.58,436.39c.14.19,1.23-.58,1.61-2.09s-.19-2.7-.41-2.61-.12,1.16-.45,2.39S250.4,436.21,250.58,436.39Z"
            fill="#263238"
          ></path>
          <path
            d="M267.22,430.47c-.07.25,1.07.72,2.13,1.72s1.66,2.07,1.9,2,0-1.49-1.29-2.64S267.25,430.23,267.22,430.47Z"
            fill="#263238"
          ></path>
          <path
            d="M270.61,426.16c-.07.08.62.85,2.05,1.66a11.65,11.65,0,0,0,2.68,1.09,12.17,12.17,0,0,0,1.68.34,3.33,3.33,0,0,0,1,0,1.11,1.11,0,0,0,1-1,1.4,1.4,0,0,0-.5-1.17,3.19,3.19,0,0,0-.85-.52A9.53,9.53,0,0,0,276,426a9.09,9.09,0,0,0-2.9-.31,4.36,4.36,0,0,0-2.56.68c0,.14,1-.11,2.57,0a10.47,10.47,0,0,1,2.66.46,9.47,9.47,0,0,1,1.47.6c.52.24.89.53.85.82,0,.1,0,.14-.23.19a2.69,2.69,0,0,1-.74,0,12.54,12.54,0,0,1-1.59-.27,14,14,0,0,1-2.59-.86A19.45,19.45,0,0,0,270.61,426.16Z"
            fill="#263238"
          ></path>
          <path
            d="M270.64,426.66c0,.09,1-.3,2.15-1.53a8.8,8.8,0,0,0,1.55-2.47,8.34,8.34,0,0,0,.49-1.67,2.17,2.17,0,0,0-.46-2.09,1.22,1.22,0,0,0-1.32-.13,3.31,3.31,0,0,0-.82.58,5.71,5.71,0,0,0-1.12,1.37,6.06,6.06,0,0,0-.86,2.83c-.06,1.71.57,2.62.64,2.57a22.45,22.45,0,0,1,0-2.51,6,6,0,0,1,.93-2.45,5.13,5.13,0,0,1,1-1.15c.42-.38.87-.6,1-.42a1.47,1.47,0,0,1,.17,1.25,8.67,8.67,0,0,1-.4,1.52,9.28,9.28,0,0,1-1.27,2.36C271.38,426,270.55,426.54,270.64,426.66Z"
            fill="#263238"
          ></path>
          <path
            d="M253.45,411.77l-17.8,22s-28.31-10.7-32-7l41.38,36,29.13-33.1Z"
            fill="#455a64"
          ></path>
          <path
            d="M250,443.09a2.25,2.25,0,0,1-.51,3,2.15,2.15,0,0,1-2.92-.48,2.37,2.37,0,0,1,.55-3.12,2.24,2.24,0,0,1,3,.84"
            fill="#e0e0e0"
          ></path>
          <path
            d="M245,462.81l2.9-3.29L207.12,426.1s-2.54-.8-3.47.68Z"
            fill="#e0e0e0"
          ></path>
          <path
            d="M235.17,433c-.17.21.76,1.18,1.19,2.69s.22,2.83.47,2.91,1-1.35.42-3.17S235.29,432.73,235.17,433Z"
            fill="#263238"
          ></path>
          <path
            d="M229.26,431c-.21.16.36,1.27.31,2.72s-.65,2.53-.44,2.69,1.33-.86,1.37-2.67S229.44,430.78,229.26,431Z"
            fill="#263238"
          ></path>
          <path
            d="M222.28,434c.14.21,1.3-.56,1.75-2.12s-.12-2.82-.35-2.73-.16,1.2-.55,2.47S222.09,433.82,222.28,434Z"
            fill="#263238"
          ></path>
          <path
            d="M239.78,428.39c-.08.26,1.09.79,2.17,1.86s1.65,2.21,1.9,2.13,0-1.55-1.25-2.8S239.82,428.15,239.78,428.39Z"
            fill="#263238"
          ></path>
          <path
            d="M243.45,424c-.07.08.62.9,2.08,1.8a12.69,12.69,0,0,0,2.75,1.22,11.36,11.36,0,0,0,1.74.4,3.16,3.16,0,0,0,1,.06,1.16,1.16,0,0,0,1-1,1.5,1.5,0,0,0-.48-1.24,4.29,4.29,0,0,0-.87-.57,11.16,11.16,0,0,0-1.68-.68,10,10,0,0,0-3-.41c-1.73.06-2.72.53-2.68.63s1.05-.08,2.66,0a11.23,11.23,0,0,1,2.76.57,11.07,11.07,0,0,1,1.51.67c.54.27.91.59.85.88,0,.11,0,.15-.24.2a3.09,3.09,0,0,1-.77,0,12.85,12.85,0,0,1-1.64-.33,15.23,15.23,0,0,1-2.68-1A18.67,18.67,0,0,0,243.45,424Z"
            fill="#263238"
          ></path>
          <path
            d="M243.46,424.54c0,.09,1.08-.28,2.29-1.52a8.85,8.85,0,0,0,1.69-2.52,8.08,8.08,0,0,0,.57-1.72,2.23,2.23,0,0,0-.41-2.19,1.27,1.27,0,0,0-1.37-.18,4,4,0,0,0-.87.57,6.14,6.14,0,0,0-1.22,1.4,6.44,6.44,0,0,0-1,2.91c-.12,1.78.51,2.75.59,2.7a20.78,20.78,0,0,1,.07-2.62,6.17,6.17,0,0,1,1-2.51,5.65,5.65,0,0,1,1.08-1.17c.45-.38.92-.59,1.05-.41a1.62,1.62,0,0,1,.13,1.32,8.67,8.67,0,0,1-.47,1.57,9.75,9.75,0,0,1-1.4,2.41C244.25,423.85,243.38,424.42,243.46,424.54Z"
            fill="#263238"
          ></path>
          <path
            d="M366.58,228.52c4-3,10.15-.55,14.48-3.08,2.62-1.54,4-4.53,6-6.8a15.29,15.29,0,0,1,12.7-5c4.5.61,7.69,1.82,9.7,5.9,2.79-3.21,10.13-.86,13.58,2.68s4.49,8.09,4.94,13a65.16,65.16,0,0,1-2.62,25.25c-.22.72-.67,1.59-1.42,1.52-.52-.06-.86-.56-1.11-1-2.11-3.91-3.06-8.33-4.16-12.64s-2.43-8.68-5.15-12.2-7.09-6.08-11.5-5.45c-3.25.46-6.07,2.55-8.24,5s-3.84,5.32-5.82,7.95-4.35,5.09-7.4,6.31-6.89.91-9.19-1.43-2.21-6.85.6-8.55a6.46,6.46,0,0,1-5.37-11.48Z"
            fill="#263238"
          ></path>
          <path
            d="M405.87,296.34l-2.69-9.12s-12.61,1.86-16.49-10.13c-1.87-5.79-4.76-18-7.25-29.12a23.47,23.47,0,0,1,16-27.55l1.16-.36c12.74-3.15,22.54,5.92,25.34,18.74l13.86,48.9a15.55,15.55,0,0,1-10.62,19.18h0A15.57,15.57,0,0,1,405.87,296.34Z"
            fill="#ffbe9d"
          ></path>
          <path
            d="M403.17,287.22a29.29,29.29,0,0,0,14.3-9.33s-1,9.81-13.37,12.45Z"
            fill="#eb996e"
          ></path>
          <path
            d="M384.65,256.33a1.8,1.8,0,0,0,2.19,1.22,1.73,1.73,0,0,0,1.29-2.1,1.79,1.79,0,0,0-2.19-1.22A1.72,1.72,0,0,0,384.65,256.33Z"
            fill="#263238"
          ></path>
          <path
            d="M383.85,253.05c.29.16,1.29-1.21,3.14-1.78s3.49-.06,3.62-.35c.07-.13-.27-.47-1-.71a4.91,4.91,0,0,0-3,0,4.7,4.7,0,0,0-2.41,1.7C383.78,252.52,383.72,253,383.85,253.05Z"
            fill="#263238"
          ></path>
          <path
            d="M402.52,251.11a1.79,1.79,0,0,0,2.19,1.22,1.71,1.71,0,0,0,1.29-2.09,1.8,1.8,0,0,0-2.19-1.23A1.73,1.73,0,0,0,402.52,251.11Z"
            fill="#263238"
          ></path>
          <path
            d="M402.14,247.76c.28.16,1.28-1.21,3.13-1.78s3.5-.06,3.63-.35c.06-.13-.28-.47-1-.71a5,5,0,0,0-3,0,4.7,4.7,0,0,0-2.41,1.7C402.07,247.23,402,247.69,402.14,247.76Z"
            fill="#263238"
          ></path>
          <path
            d="M399.68,263.55a13.22,13.22,0,0,0-3.17.39c-.49.1-1,.15-1.15-.15a2.66,2.66,0,0,1-.12-1.5c.09-1.28.19-2.62.29-4,.35-5.72.45-10.36.22-10.37s-.71,4.61-1.06,10.33c-.07,1.41-.15,2.75-.21,4a2.81,2.81,0,0,0,.32,1.93,1.28,1.28,0,0,0,1,.45,3.18,3.18,0,0,0,.83-.14A12.54,12.54,0,0,0,399.68,263.55Z"
            fill="#263238"
          ></path>
          <path
            d="M405.52,263.15c-.31.07.31,2.08-1,4s-3.48,2.4-3.41,2.68.6.24,1.51,0a5.27,5.27,0,0,0,2.88-2.13,4.53,4.53,0,0,0,.68-3.35C406,263.52,405.65,263.09,405.52,263.15Z"
            fill="#263238"
          ></path>
          <path
            d="M399,238.34c.34.45,2.12-.36,4.37-.77s4.18-.37,4.33-.91c.06-.25-.39-.63-1.25-.9a7.33,7.33,0,0,0-3.46-.12,7.43,7.43,0,0,0-3.16,1.4C399.14,237.61,398.86,238.13,399,238.34Z"
            fill="#263238"
          ></path>
          <path
            d="M382.87,247.49c.46.32,1.6-.51,3.12-1s2.92-.59,3.08-1.12c.07-.26-.27-.62-1-.84a4.63,4.63,0,0,0-2.76.1,4.56,4.56,0,0,0-2.23,1.62C382.71,246.84,382.67,247.33,382.87,247.49Z"
            fill="#263238"
          ></path>
          <path
            d="M423.68,248c.17-.16,7.51-5,9.79,3.3s-6.52,8.89-6.6,8.65S423.68,248,423.68,248Z"
            fill="#ffbe9d"
          ></path>
          <path
            d="M428.54,256.13s.17.06.45.1a1.47,1.47,0,0,0,1.09-.27c.78-.57,1.14-2.16.77-3.67a5,5,0,0,0-1-2,1.71,1.71,0,0,0-1.39-.81.76.76,0,0,0-.75.63c0,.26,0,.41,0,.44s-.21-.09-.24-.45a1,1,0,0,1,.18-.61,1.19,1.19,0,0,1,.74-.44,2.1,2.1,0,0,1,1.87.88,5.07,5.07,0,0,1,1.14,2.17c.41,1.69,0,3.49-1.12,4.17a1.62,1.62,0,0,1-1.39.15C428.61,256.32,428.51,256.15,428.54,256.13Z"
            fill="#eb996e"
          ></path>
          <path
            d="M376.12,246.24A18.22,18.22,0,0,0,390.48,238c2.15-3.39,3.31-7.66,6.62-9.93a10.25,10.25,0,0,1,7.79-1.29,19.62,19.62,0,0,1,7.28,3.45c-.42,6.83,3.25,13.18,6.8,19a3.44,3.44,0,0,0,1.55,1.6c1.21.45,2.48-.59,3.05-1.74a10.54,10.54,0,0,0,.57-6,35.34,35.34,0,0,0-4.21-13.32,24.11,24.11,0,0,0-9.94-9.67,22.86,22.86,0,0,0-17.1-1,28.08,28.08,0,0,0-13.82,10.38,16.45,16.45,0,0,0-3.25,7.39"
            fill="#263238"
          ></path>
          <path
            d="M364,232.49a1.87,1.87,0,0,0,.29.69,3.44,3.44,0,0,0,1.68,1.34,5.42,5.42,0,0,0,3.39.08,9.49,9.49,0,0,0,2-.76,4.63,4.63,0,0,0,1.8-1.62,3.06,3.06,0,0,0,.31-2.65,2.65,2.65,0,0,0-2.4-1.55,3.31,3.31,0,0,0-1.54.27,2.86,2.86,0,0,0-1.22,1.07,3.92,3.92,0,0,0-.33,3.25,4.57,4.57,0,0,0,2.23,2.62,6.93,6.93,0,0,0,3.51.77,11.31,11.31,0,0,0,6.79-2.95,32.52,32.52,0,0,0,5-5.55,42.11,42.11,0,0,1,4.42-5.23,12.92,12.92,0,0,1,5.23-3.13,12.25,12.25,0,0,1,5.31-.26,15.22,15.22,0,0,1,7,3.27c.72.58,1.24,1.08,1.59,1.42a5.39,5.39,0,0,0,.53.52s0-.06-.11-.15-.2-.25-.36-.43a16.7,16.7,0,0,0-1.55-1.49,15.1,15.1,0,0,0-7.05-3.44,12.44,12.44,0,0,0-5.46.22,13.2,13.2,0,0,0-5.4,3.18,41.67,41.67,0,0,0-4.48,5.27,32.72,32.72,0,0,1-4.89,5.48,11,11,0,0,1-6.54,2.85,6.46,6.46,0,0,1-3.29-.71,4.13,4.13,0,0,1-2.05-2.38,3.51,3.51,0,0,1,.27-2.93,2.59,2.59,0,0,1,2.42-1.19,2.34,2.34,0,0,1,2.11,1.33,2.72,2.72,0,0,1-.26,2.36,4.32,4.32,0,0,1-1.67,1.54,8.78,8.78,0,0,1-1.93.76,5.34,5.34,0,0,1-3.27,0,3.55,3.55,0,0,1-1.66-1.23A6.16,6.16,0,0,1,364,232.49Z"
            fill="#455a64"
          ></path>
          <path
            d="M426.68,228.87a12.59,12.59,0,0,1-2.31,1.43,7.2,7.2,0,0,1-2.84.57,12.43,12.43,0,0,1-3.55-.53,10.08,10.08,0,0,1-5.18-3.76,20.25,20.25,0,0,1-1.34-2.38,2.56,2.56,0,0,0,.18.73,8.92,8.92,0,0,0,.91,1.82,9.83,9.83,0,0,0,5.31,4,11.85,11.85,0,0,0,3.68.52,7.29,7.29,0,0,0,3-.69,6.85,6.85,0,0,0,1.69-1.15C426.54,229.1,426.7,228.89,426.68,228.87Z"
            fill="#455a64"
          ></path>
          <path
            d="M428.17,234.94c0-.07-.93.44-2.51.83a11.81,11.81,0,0,1-11.56-3.37c-1.12-1.18-1.6-2.09-1.67-2.05a2.18,2.18,0,0,0,.3.66,9.94,9.94,0,0,0,1.14,1.6,11.69,11.69,0,0,0,5.43,3.47,11.51,11.51,0,0,0,6.44,0,10.1,10.1,0,0,0,1.83-.73A2.39,2.39,0,0,0,428.17,234.94Z"
            fill="#455a64"
          ></path>
          <path
            d="M410.72,253.72a.24.24,0,0,0,.19-.26.23.23,0,0,0-.24-.21.24.24,0,0,0-.19.26A.22.22,0,0,0,410.72,253.72Z"
            fill="#eb996e"
          ></path>
          <path
            d="M406.94,254a.27.27,0,0,0-.06-.53.24.24,0,0,0-.18.29A.24.24,0,0,0,406.94,254Z"
            fill="#eb996e"
          ></path>
          <path
            d="M404.54,254.69c.11,0,.18-.19.15-.38s-.16-.33-.27-.31-.19.19-.15.38S404.42,254.71,404.54,254.69Z"
            fill="#eb996e"
          ></path>
          <path
            d="M409.67,256.47c.11,0,.18-.12.16-.19s-.13-.1-.24-.07-.19.12-.17.2A.2.2,0,0,0,409.67,256.47Z"
            fill="#eb996e"
          ></path>
          <path
            d="M406.19,256.73a.24.24,0,0,0,.16-.29.23.23,0,0,0-.26-.19.24.24,0,0,0-.16.28A.24.24,0,0,0,406.19,256.73Z"
            fill="#eb996e"
          ></path>
          <path
            d="M388.71,259.94a.23.23,0,0,0,.19-.26.24.24,0,0,0-.24-.22.24.24,0,0,0,0,.48Z"
            fill="#eb996e"
          ></path>
          <path
            d="M386.23,260.47a.28.28,0,1,0-.26-.22A.25.25,0,0,0,386.23,260.47Z"
            fill="#eb996e"
          ></path>
          <path
            d="M390.85,259.34a.2.2,0,0,0,.2-.21.2.2,0,0,0-.23-.16.2.2,0,0,0-.2.21A.2.2,0,0,0,390.85,259.34Z"
            fill="#eb996e"
          ></path>
          <path
            d="M389.82,262.3a.23.23,0,0,0,.24-.22.22.22,0,1,0-.43-.05A.23.23,0,0,0,389.82,262.3Z"
            fill="#eb996e"
          ></path>
          <path
            d="M387.63,262.53a.21.21,0,0,0,.09-.27.2.2,0,0,0-.28,0,.18.18,0,0,0-.08.26A.19.19,0,0,0,387.63,262.53Z"
            fill="#eb996e"
          ></path>
          <path
            d="M251.24,321.33l18.87,11.18,7.77,2.44-8.67-10.27L254,316.43a2.82,2.82,0,0,0-3.8,1.09h0A2.82,2.82,0,0,0,251.24,321.33Z"
            fill="#263238"
          ></path>
          <path
            d="M323.17,336.81c-.78.09-25.54,1.3-26.21.06s-.82-4.84-5.67-5.6-9.89-1.85-9.89-1.85l-13-6.61s-3.23,1.49.22,4.74a50.63,50.63,0,0,0,6.22,4.82c1.21.83-.32,1.88-.32,1.88l-18.39-10a17.29,17.29,0,0,0,4.36,8l2.71,2.87a6.2,6.2,0,0,0,2.62,6.57c3.76,2.75,10.1,10.18,15.88,9.77s9.85-.46,9.85-.46l30.24,3.78Z"
            fill="#ffbe9d"
          ></path>
          <path
            d="M323.17,336.81a1.57,1.57,0,0,1,0,.29l-.05.88c-.05.82-.13,2-.23,3.49-.21,3.09-.52,7.58-.91,13.26v.16l-.16,0-30.25-3.71h0l-8.39.41c-.73,0-1.44.09-2.21.07a8.44,8.44,0,0,1-2.23-.41,16.36,16.36,0,0,1-4.09-2.06,73.08,73.08,0,0,1-7.25-5.95c-.6-.52-1.22-1-1.86-1.5a7.06,7.06,0,0,1-1.71-1.82A6.32,6.32,0,0,1,263,335l.06.25L261,333.06a27.11,27.11,0,0,1-2-2.33,18.11,18.11,0,0,1-2.85-5.65c-.07-.27-.14-.52-.2-.8l-.1-.54.49.26,18.38,10h-.26a2,2,0,0,0,.6-.66.53.53,0,0,0-.11-.66c-.46-.37-1.1-.78-1.64-1.16-1.12-.79-2.21-1.6-3.24-2.46a12.5,12.5,0,0,1-2.79-2.92,2.55,2.55,0,0,1-.3-2.06,2.8,2.8,0,0,1,1.4-1.53l.1,0,.11.06,13,6.62h-.06L291,331a7.12,7.12,0,0,1,4.14,1.84,6,6,0,0,1,1.22,1.83c.3.66.47,1.36.73,2,.08.19.09.16.26.23a3.1,3.1,0,0,0,.46.11c.33,0,.65.09,1,.12.66.06,1.3.09,1.94.11,1.27.05,2.51.06,3.69.06,2.36,0,4.53,0,6.49-.08,3.92-.09,7-.2,9.09-.27l2.39-.09.61,0h.21l-.2,0-.61.06-2.39.15c-2.09.11-5.17.27-9.09.39q-2.94.1-6.5.14c-1.19,0-2.42,0-3.7,0-.64,0-1.29-.05-2-.11-.33,0-.67-.06-1-.11-.17-.05-.34-.06-.52-.13a.72.72,0,0,1-.47-.41c-.28-.66-.45-1.32-.74-2a5.64,5.64,0,0,0-1.15-1.72,6.73,6.73,0,0,0-3.94-1.71l-9.54-1.77h-.05l-13-6.6h.21a2.28,2.28,0,0,0-1.15,1.24,2.08,2.08,0,0,0,.27,1.68,12.08,12.08,0,0,0,2.68,2.77c1,.85,2.1,1.65,3.21,2.42.57.42,1.1.73,1.71,1.22a1.09,1.09,0,0,1,.31.58,1.12,1.12,0,0,1-.1.66,2.49,2.49,0,0,1-.78.86l-.12.09-.14-.08-18.39-10,.38-.28a7.39,7.39,0,0,0,.18.75,17.53,17.53,0,0,0,2.77,5.49,25.38,25.38,0,0,0,2,2.28l2.06,2.18.1.1,0,.15a5.82,5.82,0,0,0,.79,4.49,6.76,6.76,0,0,0,1.59,1.7c.63.49,1.28,1,1.88,1.52a72.35,72.35,0,0,0,7.2,5.92,15.67,15.67,0,0,0,3.95,2,8.09,8.09,0,0,0,2.11.39c.69,0,1.44,0,2.16-.06l8.41-.39h0l30.24,3.86-.17.14c.46-5.63.83-10.09,1.08-13.16l.3-3.51.08-.91C323.15,336.92,323.17,336.82,323.17,336.81Z"
            fill="#eb996e"
          ></path>
          <path
            d="M262.3,334c-.09.15,2,1.55,4.58,3.12s4.82,2.73,4.91,2.58-2-1.55-4.58-3.12S262.39,333.81,262.3,334Z"
            fill="#eb996e"
          ></path>
          <path
            d="M267.05,415.49c-.89-1.48,32.17,21.38,32.17,21.38l31.16-34.6L388.6,461l4.84-24.86,8.83-54.32-49.65-49.41s-8.25-8.07-20.77-1C321.58,337.18,267.05,415.49,267.05,415.49Z"
            fill="#263238"
          ></path>
          <path
            d="M238.5,421.12l59.21-76.22S313.47,330,330,334.55c9.84,2.7,65.81,57.33,65.81,57.33l17.41,7.06,26.57,45.58S406.35,474.93,382,457.33c-22.82-16.51-63-68.78-63-68.78l-49.92,54.68Z"
            fill="#263238"
          ></path>
          <path
            d="M357.46,434.23s-.08-.06-.22-.2l-.62-.64c-.54-.56-1.31-1.42-2.3-2.53-2-2.22-4.8-5.48-8.27-9.56-6.95-8.18-16.52-19.63-27.22-32.59h.39l-4.75,5.36c-12.28,13.81-23.52,26.18-31.78,35-4.12,4.43-7.51,8-9.86,10.4l-2.74,2.77-.72.72-.26.23s.07-.1.22-.27l.69-.75,2.66-2.84,9.74-10.51c8.19-8.91,19.39-21.32,31.66-35.12l4.76-5.36.2-.23.19.23c10.68,13,20.21,24.46,27.08,32.69,3.44,4.08,6.22,7.37,8.15,9.67,1,1.1,1.7,2,2.23,2.58l.58.67A2.71,2.71,0,0,1,357.46,434.23Z"
            fill="#455a64"
          ></path>
          <path
            d="M412.32,435.14a5.27,5.27,0,0,1-1.29-.5,17.05,17.05,0,0,1-3.21-2,18.44,18.44,0,0,1-5.25-22.69,16.69,16.69,0,0,1,2-3.22,6.9,6.9,0,0,1,.94-1,29.59,29.59,0,0,0-2.6,4.4,18.64,18.64,0,0,0,5.14,22.26A28.58,28.58,0,0,0,412.32,435.14Z"
            fill="#455a64"
          ></path>
          <path
            d="M363.44,361c.1-.11,7.19,6.86,15.84,15.55s15.58,15.82,15.48,15.92-7.2-6.86-15.85-15.56S363.33,361.12,363.44,361Z"
            fill="#455a64"
          ></path>
          <path
            d="M461.28,317.26c-7.93-19.38-26.91-36.77-26.91-36.77S399.73,301.26,398.55,302s-40.26,28.55-40.26,28.55-47.23,1.58-59.86,1.28l-5.58,24.61s59.49,7.34,67.28,5.39c4-1,42.85-12.46,42.85-12.46s-1,13.21-1.59,19c-1,9.43-6.78,23-6.78,23s23,24.26,26.55,36.88,19.08,18.5,26.42,18.2,1.76-5.28,1.76-5.28,11.17-19.71,15-42.9S469.21,336.63,461.28,317.26Z"
            fill="#5A9ED1"
          ></path>
          <path
            d="M431.64,340.25a4.21,4.21,0,0,1-.72.3l-2.1.74c-1.83.64-4.48,1.53-7.76,2.61-6.57,2.16-15.67,5-25.77,8.07s-19.29,5.67-26,7.51c-3.33.92-6,1.64-7.91,2.12l-2.16.53a3.71,3.71,0,0,1-.76.15,4.22,4.22,0,0,1,.73-.25l2.14-.62,7.86-2.29c6.64-1.92,15.8-4.61,25.9-7.64s19.21-5.86,25.81-7.93l7.81-2.45,2.12-.65A4.86,4.86,0,0,1,431.64,340.25Z"
            fill="#263238"
          ></path>
          <path
            d="M442,330.19a11.6,11.6,0,0,1,.38-1.59,32.62,32.62,0,0,0,.76-4.35,29.09,29.09,0,0,0-10.56-25.8,30.61,30.61,0,0,0-3.59-2.57,10.1,10.1,0,0,1-1.38-.87,1.76,1.76,0,0,1,.39.16c.25.12.63.27,1.09.53a27,27,0,0,1,3.72,2.46,28.47,28.47,0,0,1,10.7,26.14,26.1,26.1,0,0,1-.94,4.36c-.14.5-.3.88-.39,1.14A1.33,1.33,0,0,1,442,330.19Z"
            fill="#263238"
          ></path>
          <path
            d="M431,432.34a3.59,3.59,0,0,1-.25-.5l-.64-1.47c-.53-1.28-1.34-3.12-2.39-5.38s-2.36-4.89-3.92-7.78-3.39-6-5.44-9.18-4.17-6.11-6.15-8.72-3.87-4.9-5.5-6.77-3-3.37-3.93-4.38c-.43-.48-.79-.87-1.08-1.18a2.07,2.07,0,0,1-.35-.44,3,3,0,0,1,.43.37L403,388c1,1,2.39,2.43,4,4.28s3.58,4.12,5.61,6.71,4.13,5.55,6.2,8.74,3.87,6.33,5.43,9.23,2.84,5.58,3.83,7.86,1.77,4.15,2.25,5.45l.54,1.51A2.15,2.15,0,0,1,431,432.34Z"
            fill="#263238"
          ></path>
          <g opacity="0.30000000000000004">
            <path d="M438.36,424c-1.2-3-3.92-5.05-6.44-7.06-10.13-8.07-18.74-17.84-27.3-27.55l22.12,32.1c.7,2.18,1.43,5.62,2.69,7.52s3.53,3.37,5.77,2.88C438.35,431.2,439.55,427,438.36,424Z"></path>
          </g>
          <g opacity="0.30000000000000004">
            <path d="M402.6,350.59c6.23,2.71,13.3,4,19.88,2.31S435,346,436.34,339.39l-33.78,9.44"></path>
          </g>
          <path
            d="M318.44,358.86a7.47,7.47,0,0,0,0-1.12,5,5,0,0,0-1.5-2.6,18.34,18.34,0,0,1-3.24-3.39,11.27,11.27,0,0,1-1.35-5.6c0-2,.18-4,.11-5.69a10.51,10.51,0,0,0-1-4.41,7,7,0,0,0-1.89-2.39c-.57-.44-.95-.61-.93-.66a2.89,2.89,0,0,1,1.05.5,6.56,6.56,0,0,1,2.09,2.38,10.55,10.55,0,0,1,1.16,4.56c.1,1.77-.09,3.71-.07,5.7a11.2,11.2,0,0,0,1.24,5.37c.85,1.47,2.2,2.37,3.1,3.38a4.9,4.9,0,0,1,1.43,2.82,2.63,2.63,0,0,1-.07.87C318.5,358.77,318.45,358.87,318.44,358.86Z"
            fill="#fafafa"
          ></path>
          <path
            d="M345.87,330.5s.13.07.25.31a1.48,1.48,0,0,1,0,1.14,2.39,2.39,0,0,1-1.27,1.28c-.64.31-1.38.55-2.16.91a15,15,0,0,0-4.76,3.56,15.37,15.37,0,0,0-3.47,6.36c-.7,2.52-.44,5-.4,7.33a16.48,16.48,0,0,1-.25,3.28,7.87,7.87,0,0,1-1.06,2.68,5.6,5.6,0,0,1-3.23,2.54,3.83,3.83,0,0,1-1.13.1c-.25,0-.39-.06-.38-.08a8.26,8.26,0,0,0,1.46-.21,5.61,5.61,0,0,0,3-2.54,7.42,7.42,0,0,0,1-2.57,17.16,17.16,0,0,0,.19-3.19c-.06-2.25-.35-4.85.38-7.47a15.36,15.36,0,0,1,3.62-6.55,15,15,0,0,1,5-3.58c.81-.35,1.57-.57,2.18-.83a2.25,2.25,0,0,0,1.22-1.09,1.43,1.43,0,0,0,.09-1C346,330.62,345.85,330.51,345.87,330.5Z"
            fill="#fafafa"
          ></path>
          <path
            d="M372.52,358.66s.29-.4.68-1.17a7.19,7.19,0,0,0,.67-3.56,9.36,9.36,0,0,0-1.86-5,21.37,21.37,0,0,0-4.85-4.58c-1.93-1.41-3.86-2.69-5.42-4.1a14.18,14.18,0,0,1-3.45-4.39,8.81,8.81,0,0,1-.94-3.64,5.53,5.53,0,0,1,.06-1c0-.23.06-.35.08-.34s0,.49.06,1.36a9.28,9.28,0,0,0,1.07,3.48,14.28,14.28,0,0,0,3.44,4.2c1.55,1.36,3.46,2.62,5.41,4a21.21,21.21,0,0,1,4.93,4.72,9.49,9.49,0,0,1,1.83,5.27,6.83,6.83,0,0,1-.85,3.66,4.4,4.4,0,0,1-.6.84C372.62,358.59,372.53,358.67,372.52,358.66Z"
            fill="#fafafa"
          ></path>
          <path
            d="M410.84,344.12s.31-.62.58-1.79a9.2,9.2,0,0,0-.37-5,12,12,0,0,0-4.52-5.88,27.63,27.63,0,0,0-8.45-3.79c-2.55-.75-5.05-1.37-7.33-2.17a23.36,23.36,0,0,1-6-3,14.43,14.43,0,0,1-3.67-3.73,9.91,9.91,0,0,1-1.4-3.08l.1.05a7.3,7.3,0,0,1-1.29.33,8.64,8.64,0,0,1,1.24-.48l.08,0,0,.08a10.94,10.94,0,0,0,1.49,3,14.64,14.64,0,0,0,3.66,3.55,23.38,23.38,0,0,0,5.89,2.84c2.25.77,4.74,1.38,7.31,2.14a27.25,27.25,0,0,1,8.58,3.91,12.15,12.15,0,0,1,4.59,6.14,9.07,9.07,0,0,1,.22,5.18,6,6,0,0,1-.52,1.32C411,344,410.86,344.13,410.84,344.12Z"
            fill="#fafafa"
          ></path>
          <path
            d="M413.75,293.42a2.39,2.39,0,0,1,.58,0h.7l1,.1a14.58,14.58,0,0,1,5.73,2.07,15.62,15.62,0,0,1,6,6.7,18.58,18.58,0,0,1,.93,11c-.65,3.89-1.83,7.45-2.5,10.75a25.78,25.78,0,0,0-.39,8.88,13.24,13.24,0,0,0,2.1,5.57c.83,1.16,1.46,1.67,1.41,1.71a8,8,0,0,1-1.57-1.59,12.8,12.8,0,0,1-2.3-5.63,25.4,25.4,0,0,1,.28-9c.66-3.35,1.81-6.91,2.46-10.75a18.39,18.39,0,0,0-.86-10.68,15.39,15.39,0,0,0-5.78-6.59,15.07,15.07,0,0,0-5.56-2.18l-.93-.15-.7-.05A3.35,3.35,0,0,1,413.75,293.42Z"
            fill="#fafafa"
          ></path>
          <path
            d="M466.1,354.38a8.52,8.52,0,0,0-2.2-1.51,10.3,10.3,0,0,0-7.13-.23c-3,.81-6,3.16-9.2,5.68a30.14,30.14,0,0,1-5.5,3.48,24,24,0,0,1-19.95.09c-3.79-1.67-7-3.51-10-4.37a15.69,15.69,0,0,0-7.22-.61,14.47,14.47,0,0,0-2.58.77,7.18,7.18,0,0,1,2.54-1,15.07,15.07,0,0,1,7.36.45c3.06.82,6.34,2.65,10.1,4.28a23.67,23.67,0,0,0,19.54-.11,29.57,29.57,0,0,0,5.43-3.41c3.25-2.48,6.27-4.85,9.39-5.65a10.43,10.43,0,0,1,7.32.4,9.35,9.35,0,0,1,1,.61c.26.22.49.39.65.56A3.76,3.76,0,0,1,466.1,354.38Z"
            fill="#fafafa"
          ></path>
          <path
            d="M464.07,334.63a1.11,1.11,0,0,1,0,.32,3,3,0,0,1-.3.86,5.64,5.64,0,0,1-2.33,2.42,8.91,8.91,0,0,1-4.86,1.12,38.89,38.89,0,0,1-6-.94,29.05,29.05,0,0,0-10.83,0c-2.74.54-4.36,1.21-4.39,1.12a4.69,4.69,0,0,1,1.12-.51,22.88,22.88,0,0,1,3.2-1,27.31,27.31,0,0,1,11-.18,44.71,44.71,0,0,0,5.93,1,8.82,8.82,0,0,0,4.66-1,5.78,5.78,0,0,0,2.33-2.19C463.93,335.05,464,334.61,464.07,334.63Z"
            fill="#fafafa"
          ></path>
          <path
            d="M458,312c0,.09-.95,0-2.46.16a18.87,18.87,0,0,0-10.69,4.42c-1.15,1-1.77,1.68-1.84,1.63a7,7,0,0,1,1.6-1.91,16.87,16.87,0,0,1,5.05-3.25,16.69,16.69,0,0,1,5.86-1.26A7.37,7.37,0,0,1,458,312Z"
            fill="#fafafa"
          ></path>
          <path
            d="M443.19,290.2a5.14,5.14,0,0,1-.68,1.81,15.45,15.45,0,0,1-2.75,3.8,16,16,0,0,1-3.76,2.81,5.24,5.24,0,0,1-1.81.7,29.86,29.86,0,0,0,5.2-3.88A29.44,29.44,0,0,0,443.19,290.2Z"
            fill="#fafafa"
          ></path>
          <path
            d="M462.83,397.56a5.82,5.82,0,0,1-.16-.72c0-.25-.1-.54-.16-.87s-.2-.74-.32-1.17a18.62,18.62,0,0,0-3.62-6.7,19.7,19.7,0,0,0-9.3-6.23,17,17,0,0,0-6.61-.63,44.28,44.28,0,0,0-7.09,1.42,53.32,53.32,0,0,1-7.13,1.56,28.45,28.45,0,0,1-6.83.06,30.23,30.23,0,0,1-10.95-3.46,28.23,28.23,0,0,1-6.25-4.59,20.89,20.89,0,0,1-1.45-1.54,3.39,3.39,0,0,1-.45-.58,5.87,5.87,0,0,1,.53.51c.34.34.82.86,1.51,1.46a29.58,29.58,0,0,0,6.28,4.41,30.77,30.77,0,0,0,10.84,3.32,29.57,29.57,0,0,0,6.7-.09,56.4,56.4,0,0,0,7.07-1.57,44.12,44.12,0,0,1,7.17-1.42,17.58,17.58,0,0,1,6.8.68,20,20,0,0,1,9.45,6.45,18.24,18.24,0,0,1,3.53,6.89c.1.45.21.84.27,1.19s.08.63.11.89A3.35,3.35,0,0,1,462.83,397.56Z"
            fill="#fafafa"
          ></path>
          <path
            d="M408.65,395.93a5.47,5.47,0,0,1-2,.28,13.92,13.92,0,0,1-4.92-.89,13.73,13.73,0,0,1-4.28-2.57,5.32,5.32,0,0,1-1.35-1.55,21.61,21.61,0,0,0,5.82,3.64A21.09,21.09,0,0,0,408.65,395.93Z"
            fill="#fafafa"
          ></path>
          <path
            d="M456.07,426.24a2.35,2.35,0,0,1-.48.19,7.32,7.32,0,0,1-1.45.32,10.56,10.56,0,0,1-5.37-.9,18,18,0,0,1-6.42-4.92c-2-2.32-3.73-5.2-5.77-8a30.31,30.31,0,0,0-3.26-3.86,19.6,19.6,0,0,0-3.73-2.84,21.51,21.51,0,0,0-7.46-2.71,25.37,25.37,0,0,0-7.36,0,1.89,1.89,0,0,1,.5-.15,12.74,12.74,0,0,1,1.46-.27,20.12,20.12,0,0,1,5.46,0,21.29,21.29,0,0,1,7.64,2.65,19.82,19.82,0,0,1,3.84,2.89A29,29,0,0,1,437,412.6c2.06,2.85,3.77,5.72,5.71,8a18,18,0,0,0,6.21,4.89,10.7,10.7,0,0,0,5.2,1C455.38,426.44,456.06,426.18,456.07,426.24Z"
            fill="#fafafa"
          ></path>
          <path
            d="M440,445.8c-.09,0-.1-.9-.37-2.32a16.59,16.59,0,0,0-5.54-9.51c-1.1-.94-1.88-1.4-1.83-1.48a6.78,6.78,0,0,1,2.06,1.19,14.79,14.79,0,0,1,5.67,9.74A6.39,6.39,0,0,1,440,445.8Z"
            fill="#fafafa"
          ></path>
        </g>
        <g id="freepik--Plant--inject-66">
          <path
            d="M91.39,323.06c-9.64-14.76-8.24-35.83,3.28-49.17,3.58-4.14,8.57-7.74,14-7.27s10.08,5.26,11.78,10.6,1.11,11.12.11,16.63c-1.4,7.72-3.74,15.61-9.09,21.35s-13.22,11.62-20.1,7.86"
            fill="#5A9ED1"
          ></path>
          <path
            d="M96.72,394.06a22.06,22.06,0,0,1,6.15-25c2.22-1.81,5.12-3.21,7.88-2.47s4.72,3.62,5.11,6.53-.44,5.82-1.45,8.57c-1.42,3.85-3.34,7.71-6.62,10.18s-7.86,4.79-11.07,2.23"
            fill="#5A9ED1"
          ></path>
          <path
            d="M73.47,389c2.65-13.08-4.24-27.51-16.08-33.66-3.68-1.91-8.2-3.05-11.9-1.19s-5.62,6.53-5.32,10.76,2.34,8.13,4.58,11.73c3.15,5,7,9.93,12.38,12.46s12.55,4.47,16.34-.1"
            fill="#5A9ED1"
          ></path>
          <path
            d="M75.14,353.63c4.62-14.9-3.21-33-16.26-41.52-4.05-2.65-9.18-4.5-13.7-2.77s-7.3,6.93-7.44,11.88,1.76,9.74,3.95,14.19c3.06,6.22,7,12.37,12.93,15.95s15.58,7.14,20.52,2.27"
            fill="#5A9ED1"
          ></path>
          <path
            d="M84.41,426.46a3.74,3.74,0,0,1-.15-.72c-.08-.54-.18-1.23-.31-2.08q-.09-.69-.21-1.5c-.1-.55-.22-1.14-.34-1.77-.24-1.28-.49-2.73-.91-4.3q-.28-1.2-.6-2.49l-.78-2.66c-.5-1.85-1.23-3.76-1.92-5.8a113,113,0,0,0-5.75-12.75A112.26,112.26,0,0,0,66,380.54c-1.32-1.7-2.51-3.37-3.78-4.8l-1.78-2.12-1.74-1.88c-1.08-1.21-2.15-2.23-3.08-3.13l-1.29-1.26-1.13-1-1.56-1.41a2.81,2.81,0,0,1-.52-.52,3.09,3.09,0,0,1,.6.43l1.64,1.32,1.18,1,1.32,1.23c1,.89,2.06,1.88,3.17,3.09l1.77,1.85,1.83,2.11c1.29,1.43,2.5,3.1,3.84,4.8A107,107,0,0,1,74,392.09a108,108,0,0,1,5.74,12.85c.68,2.06,1.39,4,1.87,5.86l.75,2.68c.2.87.39,1.71.57,2.51.39,1.59.61,3.05.82,4.34.1.63.2,1.23.29,1.78s.11,1.06.15,1.52c.08.85.15,1.55.2,2.1A3.66,3.66,0,0,1,84.41,426.46Z"
            fill="#263238"
          ></path>
          <path
            d="M84.07,429.14a1.13,1.13,0,0,1,0-.3c0-.23,0-.52.06-.86.08-.81.18-1.92.31-3.31.07-.73.15-1.52.24-2.39s.09-1.83.14-2.86c.08-2,.27-4.37.2-6.95,0-1.29,0-2.64,0-4.05s-.15-2.86-.22-4.38c-.1-3-.51-6.24-.88-9.63a150.65,150.65,0,0,0-4.57-21.67,149.93,149.93,0,0,0-8-20.66c-1.54-3-2.95-6-4.51-8.55-.77-1.31-1.45-2.61-2.21-3.8l-2.19-3.4c-1.34-2.2-2.78-4.05-4-5.72-.6-.83-1.14-1.62-1.67-2.31l-1.5-1.88-2.06-2.61-.53-.69a1.26,1.26,0,0,1-.16-.24s.08.06.21.2l.57.65,2.16,2.54,1.55,1.84c.54.69,1.1,1.47,1.72,2.29,1.21,1.66,2.67,3.49,4,5.68l2.24,3.4c.76,1.18,1.46,2.48,2.24,3.78,1.59,2.6,3,5.52,4.58,8.57a146.92,146.92,0,0,1,8.07,20.73,147.45,147.45,0,0,1,4.54,21.78c.35,3.4.74,6.63.82,9.67.06,1.52.19,3,.19,4.4s0,2.77,0,4.06c0,2.59-.19,4.93-.3,7-.07,1-.11,2-.19,2.85l-.3,2.39c-.17,1.39-.32,2.5-.42,3.3-.05.35-.09.63-.12.86A1.48,1.48,0,0,1,84.07,429.14Z"
            fill="#263238"
          ></path>
          <path
            d="M109.18,284.43s0,.1-.13.28l-.41.77L107,288.42c-.35.64-.78,1.34-1.19,2.13l-1.29,2.59c-.46.94-1,1.93-1.49,3s-1,2.22-1.51,3.42-1.09,2.44-1.63,3.76-1,2.72-1.6,4.16l-.84,2.19c-.26.75-.52,1.52-.78,2.29l-1.61,4.79c-2,6.61-4,14-5.62,21.79s-2.69,15.36-3.51,22.24-1.23,13.1-1.37,18.33c-.13,2.62-.16,5-.17,7.06s0,3.88,0,5.34,0,2.55,0,3.37c0,.36,0,.65,0,.88a1,1,0,0,1,0,.3,1.4,1.4,0,0,1,0-.3q0-.35-.06-.87c0-.82-.1-1.95-.17-3.37s-.11-3.26-.11-5.35,0-4.45.07-7.07c.09-5.25.56-11.48,1.24-18.39s1.88-14.45,3.47-22.3,3.6-15.22,5.68-21.84c.57-1.64,1.11-3.24,1.65-4.79l.79-2.3.86-2.19c.57-1.43,1.11-2.82,1.64-4.15s1.14-2.57,1.67-3.77,1-2.34,1.56-3.4l1.54-3c.48-.92.92-1.78,1.34-2.57s.87-1.48,1.24-2.11l1.75-2.89.47-.74A1.47,1.47,0,0,1,109.18,284.43Z"
            fill="#263238"
          ></path>
          <path
            d="M105.9,374.94a12.22,12.22,0,0,1-1,1.81c-.71,1.12-1.68,2.79-2.81,4.87s-2.39,4.63-3.66,7.5-2.46,6.11-3.54,9.57a101.35,101.35,0,0,0-2.47,9.9c-.58,3.09-1,5.89-1.22,8.26s-.38,4.28-.43,5.61a12.26,12.26,0,0,1-.17,2.06,12.86,12.86,0,0,1-.07-2.07c0-1.33,0-3.27.23-5.65a82.44,82.44,0,0,1,1.08-8.31,96.16,96.16,0,0,1,2.44-10,93.34,93.34,0,0,1,3.62-9.61,82.78,82.78,0,0,1,3.8-7.48c1.19-2.07,2.22-3.71,3-4.8A13.08,13.08,0,0,1,105.9,374.94Z"
            fill="#263238"
          ></path>
          <polygon
            points="65.47 419.82 107.83 419.82 102.71 463.09 70.75 463.09 65.47 419.82"
            fill="#455a64"
          ></polygon>
          <polygon
            points="67.02 458.42 70.61 463.09 102.71 463.09 106.41 458.57 67.02 458.42"
            fill="#263238"
          ></polygon>
          <path
            d="M106.18,432.55c0,.17-8.79.31-19.63.31s-19.64-.14-19.64-.31,8.79-.32,19.64-.32S106.18,432.37,106.18,432.55Z"
            fill="#fafafa"
          ></path>
          <path
            d="M106.18,435.43c0,.17-8.79.31-19.63.31s-19.64-.14-19.64-.31,8.79-.32,19.64-.32S106.18,435.25,106.18,435.43Z"
            fill="#fafafa"
          ></path>
          <path
            d="M105.65,438.22c0,.17-8.48.31-18.94.31s-18.95-.14-18.95-.31,8.48-.32,18.95-.32S105.65,438,105.65,438.22Z"
            fill="#fafafa"
          ></path>
        </g>
      </svg>
    </Box>
  );
}

export default memo(BackgroundIllustration);
